export const HARDCODED_PUBLIC_GAMES = {
  data: [
    {
      id: 1,
      name: 'Axie Infinity: Origins',
      slug: 'origins',
      logoUrl:
        'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-game.png',
      thumbnailUrl:
        'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-thumbnail.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 2,
          slug: 'turn-based',
          name: 'Turn-based',
          description: '',
        },
        {
          id: 3,
          slug: 'strategy',
          name: 'Strategy',
          description: '',
        },
        {
          id: 4,
          slug: 'adventure',
          name: 'Adventure',
          description: '',
        },
      ],
    },
    {
      id: 5,
      name: 'Axie Infinity: Homeland',
      slug: 'homeland',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706002040-homeland_app_icon.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706002032-game_thumbnail.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 3,
          slug: 'strategy',
          name: 'Strategy',
          description: '',
        },
        {
          id: 4,
          slug: 'adventure',
          name: 'Adventure',
          description: '',
        },
        {
          id: 23,
          slug: 'build-and-battle',
          name: 'Build & Battle',
          description: '',
        },
      ],
    },
    {
      id: 2,
      name: 'Axie Classic',
      slug: 'classic',
      logoUrl: 'https://cdn.skymavis.com/mavis-hub/assets/1721977430-icon.png',
      thumbnailUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1721977448-sc_1.jpg',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 2,
          slug: 'turn-based',
          name: 'Turn-based',
          description: '',
        },
        {
          id: 3,
          slug: 'strategy',
          name: 'Strategy',
          description: '',
        },
      ],
    },
    {
      id: 3,
      name: 'Axie Infinity: Raylights',
      slug: 'raylights',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688981158-raylights-youtube-thumbnail.jpg',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688981162-raylights-youtube-thumbnail.jpg',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 14,
          slug: 'puzzle',
          name: 'Puzzle',
          description: '',
        },
      ],
    },
    {
      id: 4,
      name: 'Defenders of Lunacian Land',
      slug: 'doll',
      logoUrl:
        'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-icon.png',
      thumbnailUrl:
        'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-banner.jpeg',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 7,
          slug: 'action-rpg',
          name: 'Action RPG',
          description: '',
        },
        {
          id: 22,
          slug: 'survival',
          name: 'Survival',
          description: '',
        },
      ],
    },
    {
      id: 25,
      name: 'Axie Quest',
      slug: 'axie-quest',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696404166-FA_axiequest_wildcard-KevinYap.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696404180-FA_axiequest_bg-KevinYap.jpg',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      event: {
        id: 1,
        code: 'greenlight',
        groupCode: '',
        title: 'Greenlight',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        websiteUrl: 'https://skymavis.com',
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        eventType: 'vote',
        slug: 'greenlight',
        status: 'processing',
        priority: 0,
        totalGame: 13,
      },
      genres: [
        {
          id: 5,
          slug: 'rpg',
          name: 'RPG',
          description: '',
        },
        {
          id: 14,
          slug: 'puzzle',
          name: 'Puzzle',
          description: '',
        },
        {
          id: 17,
          slug: 'hypercasual',
          name: 'Hypercasual',
          description: '',
        },
      ],
    },
    {
      id: 124,
      name: 'Apeiron',
      slug: 'apeiron',
      logoUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1733306114-104_logo_256x256.png',
      thumbnailUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1733306318-105_banner_1920x1080.jpg',
      fullThumbnailUrl: {
        medium:
          'https://cdn.skymavis.com/mavis-hub/assets/apeiron/game-asset-3a4f76a8-7c03-4366-9c84-c4e2b7619a0f.mp4',
        high: 'https://cdn.skymavis.com/mavis-hub/assets/apeiron/game-asset-8e7e73ba-761d-4661-9c07-6a770f0d7823.mp4',
      },
      mode: 'live',
      genres: [
        {
          id: 3,
          slug: 'strategy',
          name: 'Strategy',
          description: '',
        },
        {
          id: 4,
          slug: 'adventure',
          name: 'Adventure',
          description: '',
        },
      ],
    },
    {
      id: 125,
      name: 'Axie Champions',
      slug: 'axie-champions',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709005176-appicon_192.png',
      thumbnailUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1733303765-1708673410-mavis.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      event: {
        id: 1,
        code: 'greenlight',
        groupCode: '',
        title: 'Greenlight',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        websiteUrl: 'https://skymavis.com',
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        eventType: 'vote',
        slug: 'greenlight',
        status: 'processing',
        priority: 0,
        totalGame: 13,
      },
      genres: [
        {
          id: 5,
          slug: 'rpg',
          name: 'RPG',
          description: '',
        },
        {
          id: 14,
          slug: 'puzzle',
          name: 'Puzzle',
          description: '',
        },
        {
          id: 15,
          slug: 'match-3',
          name: 'Match-3',
          description: '',
        },
      ],
    },
    {
      id: 126,
      name: 'Wild Forest',
      slug: 'wild-forest',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172953-wf_logo.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172956-banner_wf.png',
      fullThumbnailUrl: {
        medium:
          'https://cdn.skymavis.com/mavis-hub/assets/wild-forest/game-asset-875b7f71-446f-45d5-8375-df4b7afc70f2.mp4',
        high: 'https://cdn.skymavis.com/mavis-hub/assets/wild-forest/game-asset-cba823b1-aa7e-4f8a-9e5f-84ace2b71596.mp4',
      },
      mode: 'live',
      genres: [
        {
          id: 3,
          slug: 'strategy',
          name: 'Strategy',
          description: '',
        },
      ],
    },
    {
      id: 129,
      name: 'PuffGo',
      slug: 'puffgo',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172466-puffgologo-192_192.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172492-puffgobanner-564_376.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 1,
          slug: 'early-access',
          name: 'Early access',
          description: '',
        },
        {
          id: 13,
          slug: 'battle-royale',
          name: 'Battle Royale',
          description: '',
        },
      ],
    },
    {
      id: 130,
      name: 'Duet Monsters',
      slug: 'duet-monsters',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645456-icon_512x512.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645512-feature_808x500.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 17,
          slug: 'hypercasual',
          name: 'Hypercasual',
          description: '',
        },
        {
          id: 24,
          slug: 'music',
          name: 'Music',
          description: '',
        },
      ],
    },
    {
      id: 131,
      name: 'Tribesters - Keeper of Secrets',
      slug: 'tribesters-ko-s',
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715072899-kosgameicon192x192.png',
      thumbnailUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715055788-gamethumbnail.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 1,
          slug: 'early-access',
          name: 'Early access',
          description: '',
        },
        {
          id: 4,
          slug: 'adventure',
          name: 'Adventure',
          description: '',
        },
      ],
    },
    {
      id: 142,
      name: 'Puzzle Champions',
      slug: 'puzzle-champions',
      logoUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1733220489-mavisstorelogo.png',
      thumbnailUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1733219643-hub-homepagebanner.png',
      fullThumbnailUrl: {
        medium: '',
        high: '',
      },
      mode: 'live',
      genres: [
        {
          id: 5,
          slug: 'rpg',
          name: 'RPG',
          description: '',
        },
        {
          id: 14,
          slug: 'puzzle',
          name: 'Puzzle',
          description: '',
        },
        {
          id: 15,
          slug: 'match-3',
          name: 'Match-3',
          description: '',
        },
      ],
    },
  ],
  pagination: {
    page: 1,
    pageSize: 100,
    lastPage: 1,
    totalRows: 13,
    orderBy: '',
    desc: false,
  },
}

export const HARDCODED_GREENLIGHT_EVENT = {
  bannerUrl:
    'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
  code: 'greenlight',
  description:
    'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
  eventType: 'vote',
  groupCode: '',
  priority: 0,
  slug: 'greenlight',
  status: 'processing',
  subTitle: 'Vote to choose the next games listed on Mavis Hub!',
  title: 'Greenlight',
  websiteUrl: 'https://skymavis.com',
}

export const HARDCODED_GREENLIGHT_GAMES = {
  data: [
    {
      code: 'axie-land-battles',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'Axie Land Battles is a multiplayer auto-battler game! Build unique teams of five Axies and a Land, then engage in a series of tactical battles.',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          {
            description: '',
            id: 1,
            name: 'Early access',
            slug: 'early-access',
          },
          { description: '', id: 3, name: 'Strategy', slug: 'strategy' },
          {
            description: '',
            id: 11,
            name: 'Auto Battler',
            slug: 'auto-battler',
          },
          {
            description: '',
            id: 23,
            name: 'Build \u0026 Battle',
            slug: 'build-and-battle',
          },
        ],
        id: 138,
        latestVersion: null,
        logoUrl:
          'https://cdn.skymavis.com/mavis-hub/assets/1729050179-icon192x192.png',
        metaData: ['early-testing', 'greenlight'],
        mode: '',
        name: 'Axie Land Battles',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics:
                  'Graphics card with DX10 capabilities (shader model 4.0) such as NVIDIA GeForce GTX 470 or AMD Radeon HD 6870',
                memory: '4 GB RAM',
                os: ' Windows 10 or newer',
                processor: 'Intel Core i5-2400 or AMD FX-8320 (or equivalent)',
                storage: '200MB',
              },
              recommended: {
                additionalNotes: '',
                graphics:
                  'Graphics card with DX11 or DX12 capabilities (shader model 5.0) such as NVIDIA GeForce GTX 970 or AMD Radeon RX 570',
                memory: '8 GB RAM',
                os: ' Windows 10 or newer',
                processor:
                  'Intel Core i5-7500 or AMD Ryzen 3 1200 (or equivalent)',
                storage: '200MB',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: 'GPU with support for Vulkan',
                memory: '2 GB RAM',
                os: 'Android 5.1 (Lollipop) or later',
                processor:
                  'Qualcomm Snapdragon 660, MediaTek Helio P60, or equivalent',
                storage: '200MB',
              },
              recommended: {
                additionalNotes: '',
                graphics: 'GPU with support for Vulkan',
                memory: '8 GB RAM',
                os: 'Android 8.0 (Oreo) or later',
                processor: 'Qualcomm Snapdragon 888 or later',
                storage: '200MB',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'axie-land-battles',
        socialLinks: [],
        thumbnailUrl:
          'https://cdn.skymavis.com/mavis-hub/assets/1737726696-image.png',
      },
      gameId: 138,
      gameSlug: 'axie-land-battles',
      id: 117,
      joinedAt: '2025-01-24T02:47:46.255528Z',
      organization: {
        about: '',
        id: 115,
        logoUrl:
          'https://cdn.skymavis.com/mavis-hub/assets/1729049937-handlocklogo.png',
        name: 'Handlock Studios',
        officialWebsite: '',
        partnershipType: 'axie-builder-program',
        slug: 'handlock-studios',
      },
      slug: 'axie-land-battles',
      upvoteCount: 173,
    },
    {
      code: 'axie-forge',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'Axie Forge is a casual experience where players can train each part of an Axie to claim a greater reward and level them up.',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          {
            description: '',
            id: 1,
            name: 'Early access',
            slug: 'early-access',
          },
          { description: '', id: 18, name: 'Sports', slug: 'sports' },
          { description: '', id: 21, name: 'Simulation', slug: 'simulation' },
        ],
        id: 136,
        latestVersion: null,
        logoUrl:
          'https://cdn.skymavis.com/mavis-hub/assets/1719464329-sc192x192.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Axie Forge',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
        ],
        rating: null,
        slug: 'axie-forge',
        socialLinks: [],
        thumbnailUrl:
          'https://cdn.skymavis.com/mavis-hub/assets/1719464334-tn534x376.png',
      },
      gameId: 136,
      gameSlug: 'axie-forge',
      id: 116,
      joinedAt: '2024-06-27T06:25:40.679699Z',
      organization: {
        about: '',
        id: 114,
        logoUrl: '',
        name: 'Axie Fields',
        officialWebsite: '',
        partnershipType: 'axie-builder-program',
        slug: 'axie-fields',
      },
      slug: 'axie-forge',
      upvoteCount: 98,
    },
    {
      code: 'tiny-drift',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'A fast-paced racing game where players control Axie through ractracks, overcoming obstacles and rivals',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          {
            description: '',
            id: 1,
            name: 'Early access',
            slug: 'early-access',
          },
          { description: '', id: 19, name: 'Racing', slug: 'racing' },
        ],
        id: 127,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219546-icon.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Tiny Drift',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'tiny-drift',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219552-thumbnail2.png',
      },
      gameId: 127,
      gameSlug: 'tiny-drift',
      id: 115,
      joinedAt: '2024-04-08T05:19:46.217145Z',
      organization: {
        about: '',
        id: 1,
        logoUrl: '',
        name: 'Sky Mavis',
        officialWebsite: '',
        partnershipType: 'sky-mavis',
        slug: 'sky-mavis',
      },
      slug: 'tiny-drift',
      upvoteCount: 386,
    },
    {
      code: 'lunacia-cup',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'Race, gather energy, and defeat your enemies with unique abilities in this exclusive Axie racing game!',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [{ description: '', id: 19, name: 'Racing', slug: 'racing' }],
        id: 123,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699245114-logo.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Lunacia Cup',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
        ],
        rating: null,
        slug: 'lunacia-cup',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699244887-thumbnail-mateusrocha1.png',
      },
      gameId: 123,
      gameSlug: 'lunacia-cup',
      id: 113,
      joinedAt: '2023-11-07T03:25:23.661256Z',
      organization: {
        about: '',
        id: 107,
        logoUrl: '',
        name: 'Series V Gamelabs',
        officialWebsite: 'https://lunaciacup.com',
        partnershipType: 'axie-builder-program',
        slug: 'lunacia-cup',
      },
      slug: 'lunacia-cup',
      upvoteCount: 219,
    },
    {
      code: 'itd-game',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description: 'A push-your-luck dungeon crawl game',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 2, name: 'Turn-based', slug: 'turn-based' },
          { description: '', id: 3, name: 'Strategy', slug: 'strategy' },
          { description: '', id: 4, name: 'Adventure', slug: 'adventure' },
        ],
        id: 20,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764805-DesignLogodesignfinal2-AXIELOSP.jpg',
        metaData: ['early-testing'],
        mode: '',
        name: 'Inter The Dungeon',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'itd-game',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764867-01-MainMenu-final-6-final-AXIELOSP.png',
      },
      gameId: 20,
      gameSlug: 'itd-game',
      id: 7,
      joinedAt: '2023-08-29T07:05:36.732281Z',
      organization: {
        about: '',
        id: 9,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764416-InterDoor-1.png',
        name: 'Inter The Dugeon',
        officialWebsite: 'https://interthedungeon.com/',
        partnershipType: 'axie-builder-program',
        slug: 'itd-org',
      },
      slug: 'itd-game',
      upvoteCount: 259,
    },
    {
      code: 'axie-sky-smash',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description: 'A turn-based multiplayer axie shooter game',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 2, name: 'Turn-based', slug: 'turn-based' },
          { description: '', id: 3, name: 'Strategy', slug: 'strategy' },
        ],
        id: 21,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693972808-Skysmash_LOGO-StevenLeARSEVEN.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Axie Sky Smash',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'axie-sky-smash',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693972865-Skysmash_poster_808-StevenLeARSEVEN.jpg',
      },
      gameId: 21,
      gameSlug: 'axie-sky-smash',
      id: 6,
      joinedAt: '2023-08-29T07:05:29.468249Z',
      organization: {
        about: '',
        id: 10,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692765722-OrgLogo.jpg',
        name: 'Melon Studio',
        officialWebsite: '',
        partnershipType: 'axie-builder-program',
        slug: 'skysmash-axie',
      },
      slug: 'axie-sky-smash',
      upvoteCount: 1013,
    },
    {
      code: 'tacticards',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description: 'Tactics and trading card games meet',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 2, name: 'Turn-based', slug: 'turn-based' },
          { description: '', id: 3, name: 'Strategy', slug: 'strategy' },
        ],
        id: 19,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693379672-TactiCards_Logo.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'TactiCards',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android-google-play',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'tacticards',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193091-TactiCards_Splashscreen.png',
      },
      gameId: 19,
      gameSlug: 'tacticards',
      id: 5,
      joinedAt: '2023-08-29T07:05:20.27467Z',
      organization: {
        about: '',
        id: 8,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692763265-header_logo.png',
        name: 'TactiGames',
        officialWebsite: 'https://tacticards.net/',
        partnershipType: 'axie-builder-program',
        slug: 'tacticards',
      },
      slug: 'tacticards',
      upvoteCount: 406,
    },
    {
      code: 'infinity-soccer',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description: 'Infinity Soccer: The Ultimate Axie Champions',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          {
            description: '',
            id: 1,
            name: 'Early access',
            slug: 'early-access',
          },
          { description: '', id: 18, name: 'Sports', slug: 'sports' },
        ],
        id: 16,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259699-InfinitySoccer.jpg',
        metaData: ['early-testing'],
        mode: '',
        name: 'Infinity Soccer: The Ultimate Axie Champions',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
        ],
        rating: null,
        slug: 'infinity-soccer',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259614-InfinitySoccer.jpg',
      },
      gameId: 16,
      gameSlug: 'infinity-soccer',
      id: 4,
      joinedAt: '2023-08-18T06:51:53.773765Z',
      organization: {
        about: '',
        id: 7,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259415-Logo.png',
        name: 'PixelInfinityStudios',
        officialWebsite: '',
        partnershipType: 'community-developer',
        slug: 'pixel-infinity',
      },
      slug: 'infinity-soccer',
      upvoteCount: 281,
    },
    {
      code: 'aiw',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'A 2.5d Platform Battle Royale Game for the ultimate glory and exciting rewards',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 20, name: 'Fighting', slug: 'fighting' },
          { description: '', id: 22, name: 'Survival', slug: 'survival' },
        ],
        id: 13,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650918-AIWlogo.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Axie Infinity War',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
        ],
        rating: null,
        slug: 'aiw',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650786-AIWtwitter_cover.jpg',
      },
      gameId: 13,
      gameSlug: 'aiw',
      id: 3,
      joinedAt: '2023-08-18T06:51:04.116246Z',
      organization: {
        about: '',
        id: 6,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650637-AIWlogo.png',
        name: 'AIW Team',
        officialWebsite: '',
        partnershipType: 'axie-builder-program',
        slug: 'aiw-team',
      },
      slug: 'aiw',
      upvoteCount: 340,
    },
    {
      code: 'culinary-war',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'Culinary craze takes your breath away, you just have to try it! Become one of the top chefs!',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 21, name: 'Simulation', slug: 'simulation' },
        ],
        id: 11,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1690872029-culinary_icon.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Axie Infinity: Culinary Wars',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
        ],
        rating: null,
        slug: 'culinary-war',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383441-culinary-wars.png',
      },
      gameId: 11,
      gameSlug: 'culinary-war',
      id: 2,
      joinedAt: '2023-08-08T07:27:07.967149Z',
      organization: {
        about: '',
        id: 1,
        logoUrl: '',
        name: 'Sky Mavis',
        officialWebsite: '',
        partnershipType: 'sky-mavis',
        slug: 'sky-mavis',
      },
      slug: 'culinary-war',
      upvoteCount: 756,
    },
    {
      code: 'mini-tri-force',
      event: {
        bannerUrl:
          'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
        code: 'greenlight',
        description:
          'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
        eventType: 'vote',
        groupCode: '',
        priority: 0,
        slug: 'greenlight',
        status: 'processing',
        subTitle: 'Vote to choose the next games listed on Mavis Hub!',
        title: 'Greenlight',
        websiteUrl: 'https://skymavis.com',
      },
      eventId: 1,
      eventType: 'vote',
      game: {
        about: '',
        collectibles: [],
        description:
          'The game is turn-based, with players weaving between enemies. To target the enemy, use a circular pattern to rotate around them.',
        fullThumbnailUrl: { high: '', medium: '' },
        gallery: [],
        genres: [
          { description: '', id: 2, name: 'Turn-based', slug: 'turn-based' },
          { description: '', id: 17, name: 'Hypercasual', slug: 'hypercasual' },
          { description: '', id: 22, name: 'Survival', slug: 'survival' },
        ],
        id: 10,
        latestVersion: null,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383033-com.SkyMavis.AxieMiniTriforce.png',
        metaData: ['early-testing'],
        mode: '',
        name: 'Axie Tri-force',
        officialWebsite: '',
        organization: null,
        platforms: [
          {
            os: 'windows',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'macos',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'desktop',
          },
          {
            os: 'android',
            requirements: {
              minimum: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
              recommended: {
                additionalNotes: '',
                graphics: '',
                memory: '',
                os: '',
                processor: '',
                storage: '',
              },
            },
            type: 'mobile',
          },
        ],
        rating: null,
        slug: 'mini-tri-force',
        socialLinks: [],
        thumbnailUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383103-tri-force-thumbnail.jpg',
      },
      gameId: 10,
      gameSlug: 'mini-tri-force',
      id: 1,
      joinedAt: '2023-08-08T07:22:28.727476Z',
      organization: {
        about: '',
        id: 5,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688983012-logoSquare.png',
        name: 'Little Green Games',
        officialWebsite: 'https://littlegreen.games/',
        partnershipType: 'community-developer',
        slug: 'littlegreen',
      },
      slug: 'mini-tri-force',
      upvoteCount: 365,
    },
  ],
  pagination: {
    desc: false,
    lastPage: 1,
    orderBy: '',
    page: 1,
    pageSize: 100,
    totalRows: 11,
  },
  total: 11,
}

export const HARDCODED_GAME_DETAILS: Record<string, unknown> = {
  raylights: {
    about:
      'Step into the enchanting world of Axie Infinity: Raylights, where a new and upgraded experience awaits not just landowners but EVERYONE! Join forces with fellow Axie-owners to sow minerals, uncover new combinations, utilize the maximum potential of Axie’s mineral familiarity, cultivate breathtaking plants, and create the most stunning land plots in Lunacia. With every step forward, unlock new minerals, secret recipes, and also captivating seasonal plants and minerals to enhance your land. Immerse yourself in the Raylights experience today, straight from your browser. No download or installation necessary. Let the adventure begin!',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
      {
        address: '0x8c811e3c958e190f5ec15fb376533a3398620500',
        description: '',
        id: 4,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575574-tab-land.png',
        name: 'Land',
        symbol: 'LAND',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 3,
      isIdWalletRequired: false,
    },
    description: 'Land Cultivation & Discovery',
    devPortalAppId: '8525bf49-49e6-437b-8a64-92c78b68963a',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/cGHkkIEu-20?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/cGHkkIEu-20/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1689060594-sm_ch2_1920x1080_c.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1689060594-sm_ch2_screenshot_a.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1689060594-sm_ch2_screenshot_b.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1689060594-sm_ch2_screenshot_c.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1689060593-sm_ch2_screenshot_d.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 14,
        name: 'Puzzle',
        slug: 'puzzle',
      },
    ],
    id: 3,
    latestVersion: {
      createdAt: 1673409712,
      downloadResources: [
        {
          downloadUrl: 'https://play.axieinfinity.com/raylights',
          os: 'web',
          platform: 'web',
        },
      ],
      id: 7,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl: 'https://play.axieinfinity.com/raylights',
          os: 'web',
          platform: 'web',
        },
      ],
      state: 'published',
      tag: '0.1.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688981158-raylights-youtube-thumbnail.jpg',
    metaData: [],
    mode: 'live',
    name: 'Axie Infinity: Raylights',
    officialWebsite: 'https://app.axieinfinity.com/games/raylights/',
    organization: {
      about: '',
      id: 2,
      logoUrl: '',
      name: 'Quicksave',
      officialWebsite: 'https://www.quicksave.fi/',
      partnershipType: 'sky-mavis',
      slug: 'quicksave',
    },
    platforms: [
      {
        os: 'web',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'web',
      },
    ],
    rating: null,
    slug: 'raylights',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688981162-raylights-youtube-thumbnail.jpg',
    upvoteCount: null,
  },
  homeland: {
    about:
      'Start your own village on the breathtaking planet of Lunacia. Lead your axies as they harvest, craft, and build towards a stronger homeland. Embrace infinity!',
    collectibles: [
      {
        address: '0x8c811e3c958e190f5ec15fb376533a3398620500',
        description: '',
        id: 4,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575574-tab-land.png',
        name: 'Land',
        symbol: 'LAND',
        type: 'ERC721',
      },
      {
        address: '0xa96660f0e4a3e9bc7388925d245a6d4d79e21259',
        description: '',
        id: 7,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575598-item.png',
        name: 'Land Item',
        symbol: 'ITEM',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 5,
      isIdWalletRequired: false,
    },
    description: 'A strategic land-based adventure',
    devPortalAppId: 'cae01260-0783-4720-9141-91156cf06a9b',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/ZeySoIxFCJQ?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/ZeySoIxFCJQ/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706004536-screenshot_1.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706004536-screenshot_2.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706004536-screenshot_3.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706004536-screenshot_4.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706006319-5.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
      {
        description: '',
        id: 4,
        name: 'Adventure',
        slug: 'adventure',
      },
      {
        description: '',
        id: 23,
        name: 'Build & Battle',
        slug: 'build-and-battle',
      },
    ],
    id: 5,
    latestVersion: {
      createdAt: 1736829887,
      downloadResources: [
        {
          binaryPath: 'Homeland.exe',
          binarySum:
            '95919f06ec523069ebd34a4f487edc4216893cd4966803f015c4cbbb5840da81',
          checksum:
            '62eba4c9f39298d412080903bd13e36d1d1ef132e86d3df01413453cd2b5db54',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/homeland/fd7de575-858c-4de2-9599-e09a750d05ea/windows-1.1.11.zip',
          os: 'windows',
          platform: 'desktop',
          size: 107542242,
        },
        {
          binaryPath:
            'Axie Infinity - Homeland.app/Contents/MacOS/Axie Infinity - Homeland',
          binarySum:
            '67ba6f9d9c52ceab595187c09f0329aeb7a92f79e5848da0356ecb4320ab3a79',
          checksum:
            '55be21078bfb5ea931d92b6263ab40dd8d9ca4773b2d83a3d466d0525c760ce0',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/homeland/156e9ad6-b51f-4126-9f69-96219e1068d9/macos-1.1.11.zip',
          os: 'macos',
          platform: 'desktop',
          size: 156066700,
        },
      ],
      id: 654,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Homeland.exe',
          binarySum:
            '95919f06ec523069ebd34a4f487edc4216893cd4966803f015c4cbbb5840da81',
          checksum:
            '62eba4c9f39298d412080903bd13e36d1d1ef132e86d3df01413453cd2b5db54',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/homeland/fd7de575-858c-4de2-9599-e09a750d05ea/windows-1.1.11.zip',
          os: 'windows',
          platform: 'desktop',
          size: 107542242,
        },
        {
          binaryPath:
            'Axie Infinity - Homeland.app/Contents/MacOS/Axie Infinity - Homeland',
          binarySum:
            '67ba6f9d9c52ceab595187c09f0329aeb7a92f79e5848da0356ecb4320ab3a79',
          checksum:
            '55be21078bfb5ea931d92b6263ab40dd8d9ca4773b2d83a3d466d0525c760ce0',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/homeland/156e9ad6-b51f-4126-9f69-96219e1068d9/macos-1.1.11.zip',
          os: 'macos',
          platform: 'desktop',
          size: 156066700,
        },
      ],
      state: 'published',
      tag: '1.1.11',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706002040-homeland_app_icon.png',
    metaData: [],
    mode: 'live',
    name: 'Axie Infinity: Homeland',
    officialWebsite: 'https://axieinfinity.com',
    organization: {
      about: '',
      id: 1,
      logoUrl: '',
      name: 'Sky Mavis',
      officialWebsite: '',
      partnershipType: 'sky-mavis',
      slug: 'sky-mavis',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'homeland',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1706002032-game_thumbnail.png',
    upvoteCount: null,
  },
  puffgo: {
    about:
      '**PuffGo** is an on-chain multiplayer royale party game that allows players to earn while having fun. The game contains several levels and gameplay modes that offer players a choice of matchups from solo to multiplayer. Players can collect game characters with different appearances, personalities, abilities, and costumes. Players can also use different characters to participate in various levels of games and modes based on the advantages of each.',
    collectibles: [],
    config: {
      gameId: 129,
      isIdWalletRequired: false,
    },
    description:
      'PuffGo is an on-chain multiplayer royale party game that allows players to earn while having fun.',
    devPortalAppId: '37123d5a-5ed3-4350-b4a8-55332d6d0c94',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/J19Ypn7PV6w?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/J19Ypn7PV6w/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172499-1.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172500-2.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172500-3.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172500-4.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172500-5.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 13,
        name: 'Battle Royale',
        slug: 'battle-royale',
      },
    ],
    id: 129,
    latestVersion: {
      createdAt: 1722227411,
      downloadResources: [
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/puffgo/db4ebc08-abcd-42bd-a1c1-7bfd7af62473/android-2.0.6-a.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          downloadUrl: 'https://testflight.apple.com/join/8gX0EHpR',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      id: 505,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/puffgo/db4ebc08-abcd-42bd-a1c1-7bfd7af62473/android-2.0.6-a.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          downloadUrl: 'https://testflight.apple.com/join/8gX0EHpR',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '2.0.6-a',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172466-puffgologo-192_192.png',
    metaData: [],
    mode: 'live',
    name: 'PuffGo',
    officialWebsite: '',
    organization: {
      about: '',
      id: 111,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172083-pufflogo-192_192.png',
      name: 'Puffverse',
      officialWebsite: '',
      partnershipType: 'partner-studio',
      slug: 'puffverse',
    },
    platforms: [
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
      {
        os: 'ios',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'puffgo',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/puffverse',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://x.com/Puffverse',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1713172492-puffgobanner-564_376.png',
    upvoteCount: null,
  },
  doll: {
    about:
      'Defenders of Lunacian Land is an exciting survival action game with simple gameplay and infinite possibilities. Choose your favorite Axie to defend Lunacia. Your Axie will have their own special skills within the game! Player will control an automatically attacking axie while fighting against waves of enemies. The game is designed with competition at its core. A leaderboard is maintained to prove your skills to global community. High placements on the leaderboard will reward players with monetary earnings using the Ronin blockchain.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 4,
      isIdWalletRequired: false,
    },
    description: 'Addictive Survival Action Game',
    devPortalAppId: '3929893f-d97b-4182-b574-b96dca01ec08',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-banner.jpeg',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-garg.jpeg',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-golem.jpeg',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-shiitake.jpeg',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-timber.jpeg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 7,
        name: 'Action RPG',
        slug: 'action-rpg',
      },
      {
        description: '',
        id: 22,
        name: 'Survival',
        slug: 'survival',
      },
    ],
    id: 4,
    latestVersion: {
      createdAt: 1696560297,
      downloadResources: [
        {
          binaryPath: 'Defenders of Lunacian Land.exe',
          binarySum:
            '36cebeda8be10799469b7395931075e4fbbb77e09fc7a98a4b3b5cf064e388f7',
          checksum:
            '275a055d966dc649fe0884a1f5e7aef60e5c9fd489f81a89c45dbe274f32dc87',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/doll/12c84b40-2c2e-4fad-987f-1a83ac461a7a/doll-1.6.4-2.zip',
          os: 'windows',
          platform: 'desktop',
          size: 60258387,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/doll/2349caa1-0bf7-4f40-a21d-446fa807e536/doll-1.6.4-2.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 147,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Defenders of Lunacian Land.exe',
          binarySum:
            '36cebeda8be10799469b7395931075e4fbbb77e09fc7a98a4b3b5cf064e388f7',
          checksum:
            '275a055d966dc649fe0884a1f5e7aef60e5c9fd489f81a89c45dbe274f32dc87',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/doll/12c84b40-2c2e-4fad-987f-1a83ac461a7a/doll-1.6.4-2.zip',
          os: 'windows',
          platform: 'desktop',
          size: 60258387,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/doll/2349caa1-0bf7-4f40-a21d-446fa807e536/doll-1.6.4-2.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '1.6.4-2',
    },
    logoUrl:
      'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-icon.png',
    metaData: [],
    mode: 'live',
    name: 'Defenders of Lunacian Land',
    officialWebsite: 'https://doll.tioland.com',
    organization: {
      about: '',
      id: 3,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688714290-Screenshot2023-07-07at14.17.46.png',
      name: 'Tioland',
      officialWebsite: 'https://doll.tioland.com/',
      partnershipType: 'axie-builder-program',
      slug: 'tioland',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'Android 10.0 or later',
            processor: '',
            storage: '20000 MB available space',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'doll',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.axieinfinity.com/marketplace-website/banner/game/doll-banner.jpeg',
    upvoteCount: null,
  },
  'axie-quest': {
    about:
      'Axie Quest: Puzzle Hunt is a game based on match-3 puzzle genre with a twist of exciting RPG elements. The game is designed based on the well known Axie Infinity NFTs.\n\nPlayers will be able to bring their Axies from Axie Infinity into an exciting quest in Axie Quest world. Explore and challenge the Wild Hunts using each Axie unique abilities, they are set to repel the wild monsters from bringing danger to the Axie Quest world. While the journey may be filled with challenges and brute forces, precious loots and magical artifacts can be found in the depths of the wild providing generous rewards at the same time strengthening the force of the Axies.\n\nIn the Axie Quest world, in order to take-on the wild monsters, Axies help each other to train in the Dojo, enhancing their battle skills and preparing for the next big challenge in the Wild Hunt. The royalty of the Axie Quest world, rewards Axie adventurers who are able to show great courage and exceptional skills in The Arena. The strongest and mightiest Axies will have their name in the hall of fame shown on the leaderboard, the whole world cheers for them!',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 25,
      isIdWalletRequired: false,
    },
    description:
      'A new exciting match-3 puzzle game with a twist of RPG elements that will take you on an epic adventure like never before!',
    devPortalAppId: '1625b27b-8a0d-4de8-a966-62ce7d6bea3e',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/mnmZ5g_oWn8?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/mnmZ5g_oWn8/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696481550-Battle-KevinYap.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696481565-00-AxieDetail-KevinYap.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696481579-DailyRewards-KevinYap.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696481590-DojoChallenge-KevinYap.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 5,
        name: 'RPG',
        slug: 'rpg',
      },
      {
        description: '',
        id: 14,
        name: 'Puzzle',
        slug: 'puzzle',
      },
      {
        description: '',
        id: 17,
        name: 'Hypercasual',
        slug: 'hypercasual',
      },
    ],
    id: 25,
    latestVersion: {
      createdAt: 1761949595,
      downloadResources: [
        {
          binaryPath: 'Axie Quest.app/Contents/MacOS/Axie Quest',
          binarySum:
            '8cacdb0ebb2c8ae4b1fb2031f2467f11be0d16a6c2b210faf363e8477e200bb9',
          checksum:
            'eeca842ca8fe9d0552fec5b97d634063d8b2fed48251cb2b9546e7d00738b161',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/ff185edd-c109-47da-8500-ef91081c5321/macos-8.2.0.zip',
          os: 'macos',
          platform: 'desktop',
          size: 151285850,
        },
        {
          binaryPath: 'Axie Quest.exe',
          binarySum:
            '5b22edf424b5723fec536da7f2cf7b8de9d7748ec80be8442b625c0a125afec4',
          checksum:
            '573eff81289fc1526e3f81e1468c4f0d654a7f815e6f5037e7540d3150872b2f',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/9fb64684-e263-4978-b386-dca65c28cfee/windows-8.2.0.zip',
          os: 'windows',
          platform: 'desktop',
          size: 141802627,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/22edf581-f67a-451f-9428-cf467e7071df/android-8.2.0.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 808,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Axie Quest.app/Contents/MacOS/Axie Quest',
          binarySum:
            '8cacdb0ebb2c8ae4b1fb2031f2467f11be0d16a6c2b210faf363e8477e200bb9',
          checksum:
            'eeca842ca8fe9d0552fec5b97d634063d8b2fed48251cb2b9546e7d00738b161',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/ff185edd-c109-47da-8500-ef91081c5321/macos-8.2.0.zip',
          os: 'macos',
          platform: 'desktop',
          size: 151285850,
        },
        {
          binaryPath: 'Axie Quest.exe',
          binarySum:
            '5b22edf424b5723fec536da7f2cf7b8de9d7748ec80be8442b625c0a125afec4',
          checksum:
            '573eff81289fc1526e3f81e1468c4f0d654a7f815e6f5037e7540d3150872b2f',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/9fb64684-e263-4978-b386-dca65c28cfee/windows-8.2.0.zip',
          os: 'windows',
          platform: 'desktop',
          size: 141802627,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-quest/22edf581-f67a-451f-9428-cf467e7071df/android-8.2.0.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '8.2.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696404166-FA_axiequest_wildcard-KevinYap.png',
    metaData: [],
    mode: 'live',
    name: 'Axie Quest',
    officialWebsite: '',
    organization: {
      about: '',
      id: 11,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696403789-LogoOrg.png',
      name: 'Moonreach Games',
      officialWebsite: '',
      partnershipType: 'axie-builder-program',
      slug: 'moon-reach-games',
    },
    platforms: [
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'Intel HD Graphics 4000 or better',
            memory: '4GB RAM',
            os: 'MacOS 10.9 (Mavericks) and above',
            processor: 'Intel Core i5 @ 2.5GHz',
            storage: '1GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'Intel UHD Graphics 617 or better',
            memory: '8GB RAM',
            os: 'MacOS 10.13 (High Sierra) and above',
            processor: 'Intel Core i5 (8th Gen)',
            storage: '2GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'AMD Radeon R7 240 v2 2GB / Nvidia GeForce GT 730 v2',
            memory: '4GB RAM',
            os: 'Windows 7 and above (32/64 bit)',
            processor: 'Intel Core i3-2115C 2.0GHz / AMD Athlon II X3 455',
            storage: '1GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'AMD Radeon RX 570 / NVIDIA GeForce GTX 1050 Ti',
            memory: '8GB RAM',
            os: 'Windows 10 64-bit',
            processor: 'Intel Core i5-7500 / AMD Ryzen 3 1200',
            storage: '2GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'Adreno 308 / POWERVR GE8100 or equivalent',
            memory: '4GB RAM',
            os: 'Android 5.0 (Lollipop) and later',
            processor: 'Snapdragon 425 / Mediatek MT6739 or equivalent',
            storage: '1GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'Adreno 615 / Mali-G72 MP3 or equivalent',
            memory: '4GB',
            os: 'Android 8.0 (Oreo) and later',
            processor: 'Snapdragon 670 / Mediatek Helio P60 or equivalent',
            storage: '2GB available space',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'axie-quest',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.com/invite/RY4Z97wStt',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/axiequest',
      },
      {
        type: 'gitbook',
        url: 'https://gitbook.axiequest.com/',
      },
    ],
    storeMerchantId: 7,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696404180-FA_axiequest_bg-KevinYap.jpg',
    upvoteCount: null,
  },
  'tribesters-ko-s': {
    about:
      'The Island of Solas is in a state of imbalance, with strange portals and creatures appearing all over the island. \n\n\n\nThe Island\'s magic has brought a being, our Wisp, to life to help the Tribesters solve the mystery and bring the Island back into balance. Each episode will introduce a new Village and Tribe, where players will earn NFT rewards and KUDOS points. \n\n\n\nDo you have what it takes to save the Island of Solas?',
    collectibles: [],
    config: {
      gameId: 131,
      isIdWalletRequired: false,
    },
    description:
      'Keeper of Secrets is a single-player 3D quester, solving the Tribes\' mystery on the Island of Solas.',
    devPortalAppId: 'b2a379c1-7bb2-4c9b-9138-ae8d05b38721',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/AcCNoH7Hha4?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/AcCNoH7Hha4/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073225-artgallery_1.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073225-artgallery_2.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073312-artgallery_3.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073312-artgallery_4.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073473-artgallery_5.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715073473-artgallery_6.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 4,
        name: 'Adventure',
        slug: 'adventure',
      },
    ],
    id: 131,
    latestVersion: {
      createdAt: 1744296506,
      downloadResources: [
        {
          binaryPath: 'Keeper of Secrets.exe',
          binarySum:
            '61828810889d64a0a64c557074e69236a76f62606f93e3a678d49c41f299b791',
          checksum:
            '885fa9e00ba79fe73ac07456f5dba723517005660a44457b08453c04b95d0335',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/tribesters-ko-s/6d9bd469-227c-4ae0-833a-57030e61ded8/windows-1.1.4.zip',
          os: 'windows',
          platform: 'desktop',
          size: 1709741699,
        },
        {
          binaryPath:
            'Keeper of Secrets.app/Contents/MacOS/Tribesters - Keeper of Secrets',
          binarySum:
            'ac4ab6656f48dac83ff933ecfeebfed9e8f5a3e8504935d40df203072bfafaea',
          checksum:
            '3477d57b64911f79f8a729cb535007f711d1af862bfb99c0a137ea6e09d05de2',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/tribesters-ko-s/01987ada-1366-4b44-b0ae-ff60b6e29720/macos-1.1.4.zip',
          os: 'macos',
          platform: 'desktop',
          size: 1788197961,
        },
      ],
      id: 745,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Keeper of Secrets.exe',
          binarySum:
            '61828810889d64a0a64c557074e69236a76f62606f93e3a678d49c41f299b791',
          checksum:
            '885fa9e00ba79fe73ac07456f5dba723517005660a44457b08453c04b95d0335',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/tribesters-ko-s/6d9bd469-227c-4ae0-833a-57030e61ded8/windows-1.1.4.zip',
          os: 'windows',
          platform: 'desktop',
          size: 1709741699,
        },
        {
          binaryPath:
            'Keeper of Secrets.app/Contents/MacOS/Tribesters - Keeper of Secrets',
          binarySum:
            'ac4ab6656f48dac83ff933ecfeebfed9e8f5a3e8504935d40df203072bfafaea',
          checksum:
            '3477d57b64911f79f8a729cb535007f711d1af862bfb99c0a137ea6e09d05de2',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/tribesters-ko-s/01987ada-1366-4b44-b0ae-ff60b6e29720/macos-1.1.4.zip',
          os: 'macos',
          platform: 'desktop',
          size: 1788197961,
        },
      ],
      state: 'published',
      tag: '1.1.4',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715072899-kosgameicon192x192.png',
    metaData: [],
    mode: 'live',
    name: 'Tribesters - Keeper of Secrets',
    officialWebsite: '',
    organization: {
      about: '',
      id: 113,
      logoUrl: '',
      name: 'Tribes Studio',
      officialWebsite: '',
      partnershipType: 'partner-studio',
      slug: 'tribes-studio',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '-',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'tribesters-ko-s',
    socialLinks: [
      {
        type: 'discord',
        url: '',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/TribestersWorld',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1715055788-gamethumbnail.png',
    upvoteCount: null,
  },
  tacticards: {
    about:
      'Play now TactiCards, the revolutionary Trading Card Game set in the Axie Infinity universe, that seamlessly blends the essence of Tactics and TCG genres. Command your units within a 5x5 grid, introducing a new layer of depth in card games. Build your deck, plan your strategies, and be the master tactician who dominates the leaderboard!',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 19,
      isIdWalletRequired: false,
    },
    description: 'Tactics and trading card games meet',
    devPortalAppId: 'b0ced8c6-6122-448f-b1ae-4b467d8d39d0',
    downvoteCount: 16,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/AUBf6E2pgj8?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/AUBf6E2pgj8/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193109-1_TactiCards_Strategy.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193108-2_TactiCards_Cards_Collection.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193109-3_TactiCards_Axies_Collection.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193108-4_TactiCards_Leaderboard.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193108-5_TactiCards_Spells.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
    ],
    id: 19,
    latestVersion: {
      createdAt: 1698047592,
      downloadResources: [
        {
          binaryPath: 'TactiCards.exe',
          binarySum:
            'e4f561e9b583d8ef154a888f6f63475203ae5bd303cb80b3da8ae6fc162edebf',
          checksum:
            'c157123e2a9fb76352c310c518f6e738cd5d6498d3106f07a3004271ca63e221',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/tacticards/798c6ee7-dd66-42fc-b6e0-e6f1cd6cd5e9/windows-0.2.4.zip',
          os: 'windows',
          platform: 'desktop',
          size: 127613372,
        },
        {
          binaryPath:
            'Tacticards_Mac_Alpha_0.2.4.app/Contents/MacOS/TactiCards',
          binarySum:
            'd2f008f212a9ba457ab20fc37ac3303ab35d2acc61330367950fd2954635b4a1',
          checksum:
            'f55409edc7f62d6cde9a750e9b0fbf2f8ce82733f469617f3887a065da66b225',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/tacticards/71ae474c-ec25-4214-9bc6-73041dd91788/macos-0.2.4.zip',
          os: 'macos',
          platform: 'desktop',
          size: 124412650,
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.TactiGames.TactiCards',
          os: 'android-google-play',
          platform: 'mobile',
        },
      ],
      id: 159,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'TactiCards.exe',
          binarySum:
            'e4f561e9b583d8ef154a888f6f63475203ae5bd303cb80b3da8ae6fc162edebf',
          checksum:
            'c157123e2a9fb76352c310c518f6e738cd5d6498d3106f07a3004271ca63e221',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/tacticards/798c6ee7-dd66-42fc-b6e0-e6f1cd6cd5e9/windows-0.2.4.zip',
          os: 'windows',
          platform: 'desktop',
          size: 127613372,
        },
        {
          binaryPath:
            'Tacticards_Mac_Alpha_0.2.4.app/Contents/MacOS/TactiCards',
          binarySum:
            'd2f008f212a9ba457ab20fc37ac3303ab35d2acc61330367950fd2954635b4a1',
          checksum:
            'f55409edc7f62d6cde9a750e9b0fbf2f8ce82733f469617f3887a065da66b225',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/tacticards/71ae474c-ec25-4214-9bc6-73041dd91788/macos-0.2.4.zip',
          os: 'macos',
          platform: 'desktop',
          size: 124412650,
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.TactiGames.TactiCards',
          os: 'android-google-play',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.2.4',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693379672-TactiCards_Logo.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'TactiCards',
    officialWebsite: '',
    organization: {
      about: '',
      id: 8,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692763265-header_logo.png',
      name: 'TactiGames',
      officialWebsite: 'https://tacticards.net/',
      partnershipType: 'axie-builder-program',
      slug: 'tacticards',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android-google-play',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'tacticards',
    socialLinks: [
      {
        type: 'discord',
        url: '',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/TactiCards',
      },
      {
        type: 'gitbook',
        url: 'https://docs.tacticards.net/',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693193091-TactiCards_Splashscreen.png',
    upvoteCount: 406,
  },
  'duet-monsters': {
    about:
      'Duet Monsters is a mobile dual-rhythm music game collaboration between Sky Mavis and Cadenverse where players control two monsters to collect falling fruit in sync with the music. Immerse yourself into the magical forest by building up a home for your Axies. It’s your way to play, choose solo to enjoy catchy tunes or battle against others to rise to the top of the global leaderboard. Set out on an adventurous journey through the magical world to restore harmony in the forest once and for all.',
    collectibles: [],
    config: {
      gameId: 130,
      isIdWalletRequired: false,
    },
    description:
      'A Mobile Dual Rhythm Music Game - Build, Collect, and Compete to Earn!',
    devPortalAppId: '3114c062-2851-40ed-bdbc-b1fc2a21d1e5',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645538-screenshots_1280x720_fix_01.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645544-screenshots_1280x720_fix_02.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645547-screenshots_1280x720_fix_03.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 17,
        name: 'Hypercasual',
        slug: 'hypercasual',
      },
      {
        description: '',
        id: 24,
        name: 'Music',
        slug: 'music',
      },
    ],
    id: 130,
    latestVersion: {
      createdAt: 1714705937,
      downloadResources: [
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.cadenverse.duetmonsters&hl=en&gl=US',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/vn/app/duet-monsters-dance-of-forest/id6450286436',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      id: 408,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.cadenverse.duetmonsters&hl=en&gl=US',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/vn/app/duet-monsters-dance-of-forest/id6450286436',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '1.0.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645456-icon_512x512.png',
    metaData: [],
    mode: 'live',
    name: 'Duet Monsters',
    officialWebsite: '',
    organization: {
      about: '',
      id: 112,
      logoUrl: '',
      name: 'Cadenverse',
      officialWebsite: '',
      partnershipType: 'partner-studio',
      slug: 'cadenverse',
    },
    platforms: [
      {
        os: 'android-google-play',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'Android 10.0 or later',
            processor: '',
            storage: '500 MB available space',
          },
        },
        type: 'mobile',
      },
      {
        os: 'ios',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'iOS 9.0 or later',
            processor: '',
            storage: '500 MB available space',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'duet-monsters',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.com/invite/TXfUCGwJ7j',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/duet_monsters',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1714645512-feature_808x500.png',
    upvoteCount: null,
  },
  'lunacia-cup': {
    about:
      'Get ready for an epic and exhilarating race. Lunacia Cup is a racing game that draws inspiration from classic kart games but with mechanics only Axies can provide, making it a truly unique experience.\n\nThe item system is one of the most distinctive features of Lunacia Cup. Each part of your Axie\'s body serves as an item. To use them, you must collect energy during the race and choose the right moment to employ your special abilities, creating thrilling twists and turns in the race. Be strategic, as the use of items can be the key to victory.\n\nGet ready for a racing experience filled with adrenaline, twists, and strategy in Lunacia Cup. Master the chaos of the tracks, gather energy, and utilize your Axie\'s unique abilities to claim victory in a world full of electrifying races. Are you ready to race?\n\nIf you want to register to play, click in login/register in [https://lunaciacup.com/](https://lunaciacup.com/)',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 123,
      isIdWalletRequired: false,
    },
    description:
      'Race, gather energy, and defeat your enemies with unique abilities in this exclusive Axie racing game!',
    devPortalAppId: 'e5a46e06-2891-4945-bc23-ae620336f649',
    downvoteCount: 16,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/_Tld3foL55k?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/_Tld3foL55k/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699519703-1.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699519703-2.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699519703-3.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699519703-4.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699894354-controllers.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 19,
        name: 'Racing',
        slug: 'racing',
      },
    ],
    id: 123,
    latestVersion: {
      createdAt: 1699894265,
      downloadResources: [
        {
          binaryPath: 'LunaciaCup.exe',
          binarySum:
            '2147c5e65c6ddf5e882b3326b060541291500115b419a8f8550c8e990268a405',
          checksum:
            'a4794ed4fbeae3c8a1114e9e4936d7a08cba2d7aec15676d4ad3f8d5cb86edc6',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/lunacia-cup/f4d1def1-b2f5-43af-b242-a3acffe4ec0b/windows-1.4.5.zip',
          os: 'windows',
          platform: 'desktop',
          size: 396615492,
        },
      ],
      id: 288,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'LunaciaCup.exe',
          binarySum:
            '2147c5e65c6ddf5e882b3326b060541291500115b419a8f8550c8e990268a405',
          checksum:
            'a4794ed4fbeae3c8a1114e9e4936d7a08cba2d7aec15676d4ad3f8d5cb86edc6',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/lunacia-cup/f4d1def1-b2f5-43af-b242-a3acffe4ec0b/windows-1.4.5.zip',
          os: 'windows',
          platform: 'desktop',
          size: 396615492,
        },
      ],
      state: 'published',
      tag: '1.4.5',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699245114-logo.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Lunacia Cup',
    officialWebsite: '',
    organization: {
      about: '',
      id: 107,
      logoUrl: '',
      name: 'Series V Gamelabs',
      officialWebsite: 'https://lunaciacup.com',
      partnershipType: 'axie-builder-program',
      slug: 'lunacia-cup',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'lunacia-cup',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1699244887-thumbnail-mateusrocha1.png',
    upvoteCount: 219,
  },
  'itd-game': {
    about:
      'Discover "Inter the Dungeon," a captivating dungeon crawl experience designed for casual gamers. Inspired by the spirit and mechanics of beloved board games such as Incan Gold, Munchkin, and Welcome to the Dungeon, this game invites you to embark on an adventure with your loyal Axies.\n\nVenture into a dungeon full of diverse rooms and intriguing obstacles. Decide whether to take risks and reveal another room, or exit the dungeon with your collected loot. Keep in mind that failing to resolve a room means losing all the treasures you\'ve gathered during that run.\n\n"Inter the Dungeon" also offers the opportunity to express your creativity by developing custom game content. From new cards and rooms to unique quests, you can even design episodic adventures with lasting effects on your Axies. Explore a world of endless possibilities and enjoyment in "Inter the Dungeon."',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 20,
      isIdWalletRequired: false,
    },
    description: 'A push-your-luck dungeon crawl game',
    devPortalAppId: '',
    downvoteCount: 49,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/6cSw54c2p8o?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/6cSw54c2p8o/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764938-02-HUDV2-7-final-AXIELOSP.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
      {
        description: '',
        id: 4,
        name: 'Adventure',
        slug: 'adventure',
      },
    ],
    id: 20,
    latestVersion: {
      createdAt: 1693216367,
      downloadResources: [
        {
          binaryPath: 'ITD-Alpha.exe',
          binarySum:
            '7067c8afa5f09b2077f5e645835e2555b07ffc8f60cb5d0a025b0a798a3deb85',
          checksum:
            'df1c61f2180c512dd38c5fa5fe6d9d3e5ed4e076c8286e3d37f95376e1fa247d',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/itd-game/90ea7ea0-d71f-4189-ae3a-51f79c618e70/itd-game-0.1.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 22835,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/itd-game/f49a1ddd-e656-494e-80cc-afd113cdfc93/itd-game-0.1.1.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 128,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'ITD-Alpha.exe',
          binarySum:
            '7067c8afa5f09b2077f5e645835e2555b07ffc8f60cb5d0a025b0a798a3deb85',
          checksum:
            'df1c61f2180c512dd38c5fa5fe6d9d3e5ed4e076c8286e3d37f95376e1fa247d',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/itd-game/90ea7ea0-d71f-4189-ae3a-51f79c618e70/itd-game-0.1.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 22835,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/itd-game/f49a1ddd-e656-494e-80cc-afd113cdfc93/itd-game-0.1.1.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.1.1',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764805-DesignLogodesignfinal2-AXIELOSP.jpg',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Inter The Dungeon',
    officialWebsite: '',
    organization: {
      about: '',
      id: 9,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764416-InterDoor-1.png',
      name: 'Inter The Dugeon',
      officialWebsite: 'https://interthedungeon.com/',
      partnershipType: 'axie-builder-program',
      slug: 'itd-org',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'itd-game',
    socialLinks: [
      {
        type: 'discord',
        url: 'discord.gg/Q3PFEsk5Yf',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/interthedungeon?lang=en',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692764867-01-MainMenu-final-6-final-AXIELOSP.png',
    upvoteCount: 259,
  },
  origins: {
    about:
      'Axie Infinity Origins is a card-based strategy game where players collect, own, and use an infinite variety of creatures called Axies to battle. Players can take down evil Chimeras in the Adventure mode or challenge other players in the Arena to reach the top of the Leaderboard.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
      {
        address: '0xc25970724f032af21d801978c73653c440cf787c',
        description: '',
        id: 5,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575529-tab-rune.png',
        name: 'Axie Rune',
        symbol: 'Axie Rune',
        type: 'ERC1155',
      },
      {
        address: '0x814a9c959a3ef6ca44b5e2349e3bba9845393947',
        description: '',
        id: 6,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575503-tab-charm.png',
        name: 'Axie Charm',
        symbol: 'Axie Charm',
        type: 'ERC1155',
      },
    ],
    config: {
      gameId: 1,
      isIdWalletRequired: false,
    },
    description: 'A PVP tactical card battler',
    devPortalAppId: '3ae01540-1d10-4ae9-99f1-55755dbb44bd',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-banner-key-art.png',
        type: 'image',
      },
      {
        src: 'https://www.youtube.com/embed/X2z_YIeettE?controls=0&rel=1&loop=1&autoplay=1&mute=1&showinfo=0&playlist=X2z_YIeettE',
        thumbnail:
          'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-banner-trailer-thumbnail.png',
        type: 'embed',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-banner-fight.png',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-banner-cards.png',
        type: 'image',
      },
      {
        src: 'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-banner-battle.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
      {
        description: '',
        id: 4,
        name: 'Adventure',
        slug: 'adventure',
      },
    ],
    id: 1,
    latestVersion: {
      createdAt: 1754461233,
      downloadResources: [
        {
          binaryPath: 'AxieInfinity-Origins.exe',
          binarySum:
            '9d487008821872b7f39e235b4c336145d30fed29e73b47ff1443c986d6e8fe3b',
          checksum:
            '9a2d50e56c9daf1834cd13b3af53f3ef835138fac20fe87d37873a2395e79cfc',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/37385545-d605-485e-b9dc-3ffbc4632570/windows-0.11.3-2.zip',
          os: 'windows',
          platform: 'desktop',
          size: 98677303,
        },
        {
          binaryPath:
            'Axie Infinity - Origins.app/Contents/MacOS/Axie Infinity - Origins',
          binarySum:
            '24b0006da3d144b4e11c134516d06110934cf36f696507f791b48d1b1f540013',
          checksum:
            '2864861312c8af801b069fdbbf42de1435cce7902be080041f3a04862e4538e3',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/bb9db5ce-5fce-417f-a75a-d3ddf79145fd/macos-0.11.3-2.zip',
          os: 'macos',
          platform: 'desktop',
          size: 109748529,
        },
        {
          downloadUrl: 'https://apps.apple.com/app/id6445878116',
          os: 'ios',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/b0db5e68-1507-4f49-8986-a609dbef6292/android-0.11.3-2.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.axieinfinity.mystic',
          os: 'android-google-play',
          platform: 'mobile',
        },
      ],
      id: 788,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'AxieInfinity-Origins.exe',
          binarySum:
            '9d487008821872b7f39e235b4c336145d30fed29e73b47ff1443c986d6e8fe3b',
          checksum:
            '9a2d50e56c9daf1834cd13b3af53f3ef835138fac20fe87d37873a2395e79cfc',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/37385545-d605-485e-b9dc-3ffbc4632570/windows-0.11.3-2.zip',
          os: 'windows',
          platform: 'desktop',
          size: 98677303,
        },
        {
          binaryPath:
            'Axie Infinity - Origins.app/Contents/MacOS/Axie Infinity - Origins',
          binarySum:
            '24b0006da3d144b4e11c134516d06110934cf36f696507f791b48d1b1f540013',
          checksum:
            '2864861312c8af801b069fdbbf42de1435cce7902be080041f3a04862e4538e3',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/bb9db5ce-5fce-417f-a75a-d3ddf79145fd/macos-0.11.3-2.zip',
          os: 'macos',
          platform: 'desktop',
          size: 109748529,
        },
        {
          downloadUrl: 'https://apps.apple.com/app/id6445878116',
          os: 'ios',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/origins/b0db5e68-1507-4f49-8986-a609dbef6292/android-0.11.3-2.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.axieinfinity.mystic',
          os: 'android-google-play',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.11.3-2',
    },
    logoUrl:
      'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-game.png',
    metaData: [],
    mode: 'live',
    name: 'Axie Infinity: Origins',
    officialWebsite: 'https://axieinfinity.com',
    organization: {
      about: '',
      id: 1,
      logoUrl: '',
      name: 'Sky Mavis',
      officialWebsite: '',
      partnershipType: 'sky-mavis',
      slug: 'sky-mavis',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'ios',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'iOS 9.0 or later',
            processor: '',
            storage: '20000 MB available space',
          },
        },
        type: 'mobile',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'Android 10.0 or later',
            processor: '',
            storage: '20000 MB available space',
          },
        },
        type: 'mobile',
      },
      {
        os: 'android-google-play',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'origins',
    socialLinks: [],
    storeMerchantId: 1,
    thumbnailUrl:
      'https://cdn.axieinfinity.com/marketplace-website/banner/game/origins-thumbnail.png',
    upvoteCount: null,
  },
  'tiny-drift': {
    about:
      'Axie Tiny Drift is an exhilarating mini-game within the expansive world of Axie Infinity. Players navigate their adorable Axies through challenging racetracks, mastering precise controls to outmaneuver obstacles and rivals. With vibrant visuals and competitive gameplay, Axie Tiny Drift offers a thrilling experience for Axie enthusiasts seeking fast-paced action and tactical skill-testing challenges.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 127,
      isIdWalletRequired: false,
    },
    description:
      'A fast-paced racing game where players control Axie through ractracks, overcoming obstacles and rivals',
    devPortalAppId: 'a9575c6b-10a5-450a-994f-fc80ee534473',
    downvoteCount: 57,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/GmdDReQazeY?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/GmdDReQazeY/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219576-ss0.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219575-ss1.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712587391-ss21.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219576-ss3.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219575-ss4.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219576-ss5.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 19,
        name: 'Racing',
        slug: 'racing',
      },
    ],
    id: 127,
    latestVersion: {
      createdAt: 1712587176,
      downloadResources: [
        {
          binaryPath: 'racing.exe',
          binarySum:
            '746afa3ed1be9b18cb835349950c8ccdb50b74a71006e8538b89dce55a6074b7',
          checksum:
            '4d872eb55715bd0fe950e6850bcd4a6d4ee29b3b325445c9ee8fbe19696b55ee',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/2b35ae99-934d-440c-a21d-b7bdda0a1aaf/windows-0.0.3.zip',
          os: 'windows',
          platform: 'desktop',
          size: 115899062,
        },
        {
          binaryPath: 'Axie Tiny Drift.app/Contents/MacOS/Axie Tiny Drift',
          binarySum:
            'a5639857ddd2c5ab0c46bd7956986f36ff6d01c4ceea1422d48b3d6033149684',
          checksum:
            'd4c0d57fe16e6aed0ee9e080a83fd8cbac325aa9618e649287a77aa4142b4976',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/74e977f8-ef2b-4c81-a065-2dd6672e72f7/macos-0.0.3.zip',
          os: 'macos',
          platform: 'desktop',
          size: 129316040,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/694cce87-2f3f-425d-a8a6-ee8d4ca1a4dc/android-0.0.3.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 392,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'racing.exe',
          binarySum:
            '746afa3ed1be9b18cb835349950c8ccdb50b74a71006e8538b89dce55a6074b7',
          checksum:
            '4d872eb55715bd0fe950e6850bcd4a6d4ee29b3b325445c9ee8fbe19696b55ee',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/2b35ae99-934d-440c-a21d-b7bdda0a1aaf/windows-0.0.3.zip',
          os: 'windows',
          platform: 'desktop',
          size: 115899062,
        },
        {
          binaryPath: 'Axie Tiny Drift.app/Contents/MacOS/Axie Tiny Drift',
          binarySum:
            'a5639857ddd2c5ab0c46bd7956986f36ff6d01c4ceea1422d48b3d6033149684',
          checksum:
            'd4c0d57fe16e6aed0ee9e080a83fd8cbac325aa9618e649287a77aa4142b4976',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/74e977f8-ef2b-4c81-a065-2dd6672e72f7/macos-0.0.3.zip',
          os: 'macos',
          platform: 'desktop',
          size: 129316040,
        },
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/culinary-war/694cce87-2f3f-425d-a8a6-ee8d4ca1a4dc/android-0.0.3.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.0.3',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219546-icon.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Tiny Drift',
    officialWebsite: '',
    organization: {
      about: '',
      id: 1,
      logoUrl: '',
      name: 'Sky Mavis',
      officialWebsite: '',
      partnershipType: 'sky-mavis',
      slug: 'sky-mavis',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'tiny-drift',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1712219552-thumbnail2.png',
    upvoteCount: 386,
  },
  'puzzle-champions': {
    about:
      '**Puzzle Champions** is a ***Match3 puzzle game*** with Champions. It is a simple and easy-to-play game that users can easily play while integrating RPG elements that allow gamers to collect, enhance, and trade their game items. \nUsers can play Puzzle Champions by collecting Champions and leveling them up for PVP and PVE plays. There will be rich game content including gacha, collect, upgrade, fusion, artifact, and many other RPG elements while enjoying play to earn system.',
    collectibles: [],
    config: {
      gameId: 142,
      isIdWalletRequired: false,
    },
    description:
      'Puzzle Champions is a match-3 puzzle game that everyone can enjoy play while integrating RPG elements that allow gamers to collect various Champion skills and conquer the leaderboard for prizes.',
    devPortalAppId: '',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1733219348-artgallery_02.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1733219348-artgallery_01.png',
        type: 'image',
      },
      {
        src: 'https://www.youtube.com/embed/BmSOiTeeELY?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/BmSOiTeeELY/mqdefault.jpg',
        type: 'embed',
      },
    ],
    genres: [
      {
        description: '',
        id: 5,
        name: 'RPG',
        slug: 'rpg',
      },
      {
        description: '',
        id: 14,
        name: 'Puzzle',
        slug: 'puzzle',
      },
      {
        description: '',
        id: 15,
        name: 'Match-3',
        slug: 'match-3',
      },
    ],
    id: 142,
    latestVersion: {
      createdAt: 1733220443,
      downloadResources: [
        {
          downloadUrl: 'https://puzzle3champ.baligames.net/',
          os: 'web',
          platform: 'web',
        },
      ],
      id: 625,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl: 'https://puzzle3champ.baligames.net/',
          os: 'web',
          platform: 'web',
        },
      ],
      state: 'published',
      tag: '1.0.0',
    },
    logoUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1733220489-mavisstorelogo.png',
    metaData: [],
    mode: 'live',
    name: 'Puzzle Champions',
    officialWebsite: 'https://puzzle3champ.baligames.net/',
    organization: {
      about: '',
      id: 109,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1707975400-bg_ci_dark.png',
      name: 'Bali games',
      officialWebsite: 'https://www.baligames.xyz/',
      partnershipType: 'partner-studio',
      slug: 'bali-games',
    },
    platforms: [
      {
        os: 'web',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'web',
      },
    ],
    rating: null,
    slug: 'puzzle-champions',
    socialLinks: [
      {
        type: 'discord',
        url: '',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://x.com/AxieChampions',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1733219643-hub-homepagebanner.png',
    upvoteCount: null,
  },
  classic: {
    about:
      'Classic, released in December 2019, grew the Axie community from a ragtag band of a few hundred missionaries to millions. The game is structured as a turn-based card battler where players create teams of Axies to duke it out in the arena. Axies draw cards based on the body parts they posses and you must play these cards at the optimal time and order to maximize your chance of victory. Classic was the first game ever to distribute in-game resources as ERC20 tokens.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 2,
      isIdWalletRequired: false,
    },
    description: 'A 1v1 turn-based tactical card game',
    devPortalAppId: '94857b65-d40a-4fbe-a964-27206436d006',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/H0Dh_uvCuFU?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/H0Dh_uvCuFU/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1721977471-sc_2.jpg',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1721977471-sc_3.jpg',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1721977471-sc_4.jpg',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1721977471-sc_5.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
    ],
    id: 2,
    latestVersion: {
      createdAt: 1759289066,
      downloadResources: [
        {
          binaryPath: 'axie_game.exe',
          binarySum:
            '6c135cfbca7c3b832469c29b64ae4184a4e68de755c2bf6fc2f478b9052bcaec',
          checksum:
            '9d1b9e5bb005bc67426b251c4d531c33cc0d1b240c7541c7394357841cda47b2',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/af9d8aae-4233-47eb-926d-94487d96f272/windows-1.2.33-44b.zip',
          os: 'windows',
          platform: 'desktop',
          size: 119874925,
        },
        {
          binaryPath: 'Axie Infinity.app/Contents/MacOS/Axie Infinity',
          binarySum:
            '8c014c8a7bbf47a81d7f9392cfa1358b2d63a235c6a3fadf0835e646841ea1c5',
          checksum:
            '87549d44f0318fd4fa3c03dd0ed4ea2264d1da5fab4b2f15138d0a8035eb0b9d',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/8272c491-30a7-4371-96c9-ac0b0052c32e/macos-1.2.33-44b.zip',
          os: 'macos',
          platform: 'desktop',
          size: 134149271,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/e9f139a7-a073-4bbf-adf1-9666297ca64b/android-1.2.33-44b.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 804,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'axie_game.exe',
          binarySum:
            '6c135cfbca7c3b832469c29b64ae4184a4e68de755c2bf6fc2f478b9052bcaec',
          checksum:
            '9d1b9e5bb005bc67426b251c4d531c33cc0d1b240c7541c7394357841cda47b2',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/af9d8aae-4233-47eb-926d-94487d96f272/windows-1.2.33-44b.zip',
          os: 'windows',
          platform: 'desktop',
          size: 119874925,
        },
        {
          binaryPath: 'Axie Infinity.app/Contents/MacOS/Axie Infinity',
          binarySum:
            '8c014c8a7bbf47a81d7f9392cfa1358b2d63a235c6a3fadf0835e646841ea1c5',
          checksum:
            '87549d44f0318fd4fa3c03dd0ed4ea2264d1da5fab4b2f15138d0a8035eb0b9d',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/8272c491-30a7-4371-96c9-ac0b0052c32e/macos-1.2.33-44b.zip',
          os: 'macos',
          platform: 'desktop',
          size: 134149271,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/classic/e9f139a7-a073-4bbf-adf1-9666297ca64b/android-1.2.33-44b.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '1.2.33-44b',
    },
    logoUrl: 'https://cdn.skymavis.com/mavis-hub/assets/1721977430-icon.png',
    metaData: [],
    mode: 'live',
    name: 'Axie Classic',
    officialWebsite: 'https://axieinfinity.com',
    organization: {
      about: '',
      id: 1,
      logoUrl: '',
      name: 'Sky Mavis',
      officialWebsite: '',
      partnershipType: 'sky-mavis',
      slug: 'sky-mavis',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'NVIDIA GTX 670 2GB / AMD Radeon HD7870 wGB or better',
            memory: '8 GB RAM',
            os: 'Windows 7/8/8.1/10 (64-bit versions)',
            processor:
              'Intel Core i5/i7/i9/Xeon/Ryzen/Athlon/Phenom/Athlon XP/Athlon MP/Athton XP/Athlon MP',
            storage: '500 GB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'OpenGL 3 Compatible GPU with 1GB Video RAM',
            memory: '4000 MB RAM',
            os: 'OSX 10.9 or Higher',
            processor: '2 GHz Equivalent CPU',
            storage: '20000 MB available space',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: 'Android 10.0 or later',
            processor: '',
            storage: '20000 MB available space',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'classic',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1721977448-sc_1.jpg',
    upvoteCount: null,
  },
  'axie-champions': {
    about:
      'Axie Champions is a Match3 Puzzle RPG game, simple and easy-to-play for everyone. Gamers can collect, upgrade, and trade their Champions to win the Champions League!Login with your Mavis Account and let your Axies ride on the Champions!Various PVE modes, item Upgrades, and Champion Fusion will make your Champions Stronger.. Build your own Champion team for the Battle and aim for the Championship Prize!',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 125,
      isIdWalletRequired: false,
    },
    description:
      'Match3 Puzzle RPG game - collect, upgrade, trade your Champions and compete with other players at the Champions League!',
    devPortalAppId: '85159971-4c10-464b-aa69-1e77cc0903e3',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1708673410-mavis.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1708673410-mavishub_02.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1708673410-mavishub_03.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 5,
        name: 'RPG',
        slug: 'rpg',
      },
      {
        description: '',
        id: 14,
        name: 'Puzzle',
        slug: 'puzzle',
      },
      {
        description: '',
        id: 15,
        name: 'Match-3',
        slug: 'match-3',
      },
    ],
    id: 125,
    latestVersion: {
      createdAt: 1736299888,
      downloadResources: [
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-champions/518ea5d9-39a6-417b-bfdd-77edbfc813b5/android-0.9.2-258.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 651,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-champions/518ea5d9-39a6-417b-bfdd-77edbfc813b5/android-0.9.2-258.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.9.2-258',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709005176-appicon_192.png',
    metaData: [],
    mode: 'live',
    name: 'Axie Champions',
    officialWebsite: 'https://puzzle3champ.baligames.net/',
    organization: {
      about: '',
      id: 109,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1707975400-bg_ci_dark.png',
      name: 'Bali games',
      officialWebsite: 'https://www.baligames.xyz/',
      partnershipType: 'partner-studio',
      slug: 'bali-games',
    },
    platforms: [
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'Adreno 308 / POWERVR GE8100 or equivalent',
            memory: 'RAM 2G+',
            os: 'Android 7.0 and later',
            processor: 'Snapdragon 425 / Mediatek MT6739 or equivalent',
            storage: '1GB available space',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'Adreno 615 / Mali-G72 MP3 or equivalent',
            memory: 'RAM 2G+',
            os: 'Android 10.0 or later',
            processor: 'Snapdragon 670 / Mediatek Helio P60 or equivalent',
            storage: '2GB available space',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'axie-champions',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/axiechampions',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://x.com/AxieChampions',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1733303765-1708673410-mavis.png',
    upvoteCount: null,
  },
  'mini-tri-force': {
    about:
      'Your forest has been poisoned by an unknown entity, which has turned everything into a ferocious and bloody state. This disastrous incident has put your Axie clan in grave danger, as it is now under constant threat. However, you do not have to face this challenge alone. Together, let us work towards defeating the youkai, the mystical creatures that protect the forest and your species. By doing so, we can restore the balance in the forest and ensure the survival of your clan and all the other creatures that inhabit it.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 10,
      isIdWalletRequired: false,
    },
    description:
      'The game is turn-based, with players weaving between enemies. To target the enemy, use a circular pattern to rotate around them.',
    devPortalAppId: 'd41ed67b-11c7-4b7c-8825-76c655f4f242',
    downvoteCount: 70,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/FVifwNUUpgE?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/FVifwNUUpgE/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691483095-image1.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691483095-image2.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691483094-image3.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691483095-image4.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 17,
        name: 'Hypercasual',
        slug: 'hypercasual',
      },
      {
        description: '',
        id: 22,
        name: 'Survival',
        slug: 'survival',
      },
    ],
    id: 10,
    latestVersion: {
      createdAt: 1691479323,
      downloadResources: [
        {
          binaryPath: 'Axie Tri-Force.app/Contents/MacOS/Axie Tri-Force',
          binarySum:
            'fd5912165776182f81cbd7e7cd9f4f0035010a50aa16116cd617e1aeefd51792',
          checksum:
            '15f5368497e5a56fecaa3761bdd80b33a07cb9d3ee450deccd2ddd3e3c32581e',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/tri-force/tri-force-dev-0.0.1-macos-20230808-1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 72479995,
        },
        {
          binaryPath: 'tri-force.exe',
          binarySum:
            'e3cbbacbf75504cd5eda70c1bf813ef616f6591af088914c0f6af37830468f1f',
          checksum:
            'c662d3f78bb469ea7077854a5693f987211fa1ffa0fe7621d8e4a95de6bc4ef6',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/tri-force/tri-force-dev-0.0.1-windows-20230808-1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 58767715,
        },
      ],
      id: 106,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Axie Tri-Force.app/Contents/MacOS/Axie Tri-Force',
          binarySum:
            'fd5912165776182f81cbd7e7cd9f4f0035010a50aa16116cd617e1aeefd51792',
          checksum:
            '15f5368497e5a56fecaa3761bdd80b33a07cb9d3ee450deccd2ddd3e3c32581e',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/tri-force/tri-force-dev-0.0.1-macos-20230808-1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 72479995,
        },
        {
          binaryPath: 'tri-force.exe',
          binarySum:
            'e3cbbacbf75504cd5eda70c1bf813ef616f6591af088914c0f6af37830468f1f',
          checksum:
            'c662d3f78bb469ea7077854a5693f987211fa1ffa0fe7621d8e4a95de6bc4ef6',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/tri-force/tri-force-dev-0.0.1-windows-20230808-1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 58767715,
        },
      ],
      state: 'published',
      tag: '0.1.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383033-com.SkyMavis.AxieMiniTriforce.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Axie Tri-force',
    officialWebsite: '',
    organization: {
      about: '',
      id: 5,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1688983012-logoSquare.png',
      name: 'Little Green Games',
      officialWebsite: 'https://littlegreen.games/',
      partnershipType: 'community-developer',
      slug: 'littlegreen',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'mini-tri-force',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/7hphfmmb',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: '',
      },
      {
        type: 'gitbook',
        url: 'https://littlegreen.gitbook.io/axie-mini-tri-force/',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383103-tri-force-thumbnail.jpg',
    upvoteCount: 365,
  },
  'culinary-war': {
    about:
      'Culinary craze takes your breath away, you just have to try it! Become one of the top chefs!\n\nIt won\'t be easy, because madness always reigns in the kitchen! Orders are received constantly, but you are the best chef and can handle it! This is a really tough cooking challenge! Hurry up, hungry travelers are waiting for virtual cooking masterpieces!\n\nGet ready to cook on time to please your customers and you earn more and more money every day! Move around the map and discover new kitchens that need a super chef!\n\nMake juices, salads, chips, baked corn and other dishes - for a crazy talented chef there\'s nothing he can\'t cook! Put on your chef\'s hat and step into the crazy kitchen!',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 11,
      isIdWalletRequired: false,
    },
    description:
      'Culinary craze takes your breath away, you just have to try it! Become one of the top chefs!',
    devPortalAppId: '',
    downvoteCount: 31,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/JI781Q3P-fo?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/JI781Q3P-fo/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691482961-ss1.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691482961-ss2.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691482961-ss3.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691482961-ss4.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 21,
        name: 'Simulation',
        slug: 'simulation',
      },
    ],
    id: 11,
    latestVersion: {
      createdAt: 1691811853,
      downloadResources: [
        {
          binaryPath: 'culinary-wars.exe',
          binarySum:
            '2956bfb8eb2643c896ddf99e5c6663906a5dae283fd3aa0aab79f6db3d9a4339',
          checksum:
            'cae6d33f5e31ec316cd08c70d1858720253b445e3b3205970beeffc591522c66',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/culinary-wars/culinary-wars-dev-0.0.2-windows-20230811-1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 71956260,
        },
        {
          binaryPath: 'Axie Culinary War.app/Contents/MacOS/Axie Culinary War',
          binarySum:
            'd89c27171cd3b0ddc44599bee28c1ef9c4ab46adcd842137b0306bf36020b987',
          checksum:
            '2311c925329216b9ca9b702f12fa5d2f65d85efbf9c276b8d9442b252ab0e6cc',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/culinary-wars/culinary-wars-dev-0.0.2-macos-20230811-1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 85466774,
        },
      ],
      id: 109,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'culinary-wars.exe',
          binarySum:
            '2956bfb8eb2643c896ddf99e5c6663906a5dae283fd3aa0aab79f6db3d9a4339',
          checksum:
            'cae6d33f5e31ec316cd08c70d1858720253b445e3b3205970beeffc591522c66',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/culinary-wars/culinary-wars-dev-0.0.2-windows-20230811-1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 71956260,
        },
        {
          binaryPath: 'Axie Culinary War.app/Contents/MacOS/Axie Culinary War',
          binarySum:
            'd89c27171cd3b0ddc44599bee28c1ef9c4ab46adcd842137b0306bf36020b987',
          checksum:
            '2311c925329216b9ca9b702f12fa5d2f65d85efbf9c276b8d9442b252ab0e6cc',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/games/culinary-wars/culinary-wars-dev-0.0.2-macos-20230811-1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 85466774,
        },
      ],
      state: 'published',
      tag: '0.2.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1690872029-culinary_icon.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Axie Infinity: Culinary Wars',
    officialWebsite: '',
    organization: {
      about: '',
      id: 1,
      logoUrl: '',
      name: 'Sky Mavis',
      officialWebsite: '',
      partnershipType: 'sky-mavis',
      slug: 'sky-mavis',
    },
    platforms: [
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'culinary-war',
    socialLinks: [],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691383441-culinary-wars.png',
    upvoteCount: 756,
  },
  'axie-sky-smash': {
    about:
      'Sky Smash is a turn-based, 2D, cross-platform multiplayer game, inspired by the classic Gunbound game by Korean game studio Softnyx. \nThe goal of Sky Smash is to create a tactical, skill-based and social game for axie-holders. \nIn Sky Smash, players are arranged into two opposing teams of maximum 4 players each, which take turn shooting at each other using their own axies in a 2D map featuring destructible environment. This creates a team-base, coordinating game that can be rewarding to play with your group of friends or guild-mates. \nThe game also encourages players to have many axies and use them in-game to discover different aspects of gameplay. Each axie body types, classes and parts all contribute to how the axie behave in the game, thus forcing the players to devise their own strategy for their unique axies in each Sky Smash game.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 21,
      isIdWalletRequired: false,
    },
    description: 'A turn-based multiplayer axie shooter game',
    devPortalAppId: 'b4d64385-e07d-486f-a48c-a0caee785502',
    downvoteCount: 24,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/VI2RCI11x8Y?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/VI2RCI11x8Y/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693973001-promo1-StevenLeARSEVEN.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693973230-promo2-StevenLeARSEVEN.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693973234-promo3-StevenLeARSEVEN.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693973234-promo4-StevenLeARSEVEN.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 2,
        name: 'Turn-based',
        slug: 'turn-based',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
    ],
    id: 21,
    latestVersion: {
      createdAt: 1723283309,
      downloadResources: [
        {
          binaryPath: 'Sky Smash.exe',
          binarySum:
            '295898ab93aafa160b9881b1b884d1c2d91e266fbfc13d48849f625b469929e7',
          checksum:
            '5396c258fae904874f2207a7e80ee6a91f4fad154e957d7b6fc874438acba712',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/5edccb72-5a0d-4968-879d-cfbf1897513e/windows-0.2.5.zip',
          os: 'windows',
          platform: 'desktop',
          size: 140606656,
        },
        {
          binaryPath: 'MacOs.app/Contents/MacOS/Sky Smash',
          binarySum:
            '88108465b5811d165b5a58eafcc544b8d0ce10b4c0fae628cb108c0862f1a66c',
          checksum:
            '960ebfbfed2b545802adc86e42be7a8424913e3f07e6661ceb6bc04e4639a40c',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/b52f7c60-d093-4fae-a246-187c9f07833d/macos-0.2.5.zip',
          os: 'macos',
          platform: 'desktop',
          size: 170695982,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/07de765a-60b2-44bf-a649-6a9573e7a713/android-0.2.5.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 517,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Sky Smash.exe',
          binarySum:
            '295898ab93aafa160b9881b1b884d1c2d91e266fbfc13d48849f625b469929e7',
          checksum:
            '5396c258fae904874f2207a7e80ee6a91f4fad154e957d7b6fc874438acba712',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/5edccb72-5a0d-4968-879d-cfbf1897513e/windows-0.2.5.zip',
          os: 'windows',
          platform: 'desktop',
          size: 140606656,
        },
        {
          binaryPath: 'MacOs.app/Contents/MacOS/Sky Smash',
          binarySum:
            '88108465b5811d165b5a58eafcc544b8d0ce10b4c0fae628cb108c0862f1a66c',
          checksum:
            '960ebfbfed2b545802adc86e42be7a8424913e3f07e6661ceb6bc04e4639a40c',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/b52f7c60-d093-4fae-a246-187c9f07833d/macos-0.2.5.zip',
          os: 'macos',
          platform: 'desktop',
          size: 170695982,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-sky-smash/07de765a-60b2-44bf-a649-6a9573e7a713/android-0.2.5.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.2.5',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693972808-Skysmash_LOGO-StevenLeARSEVEN.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Axie Sky Smash',
    officialWebsite: '',
    organization: {
      about: '',
      id: 10,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692765722-OrgLogo.jpg',
      name: 'Melon Studio',
      officialWebsite: '',
      partnershipType: 'axie-builder-program',
      slug: 'skysmash-axie',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'axie-sky-smash',
    socialLinks: [
      {
        type: 'discord',
        url: '',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/skysmashaxie',
      },
      {
        type: 'gitbook',
        url: 'https://docs.skysmash.io/',
      },
    ],
    storeMerchantId: 4,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1693972865-Skysmash_poster_808-StevenLeARSEVEN.jpg',
    upvoteCount: 1013,
  },
  'axie-forge': {
    about:
      'As the player special Axies (Starter Axies) levels up, it will unlock mini-games where players can compete and receive rewards.\n\nThe IDLE experience is the center of the project. The player will initially have to equip a gym to train their Axies. Each part of an Axie requires a special machine to train it, and once an Axie has trained each of its body parts, it can claim a reward and additionally gain experience to level up.\nTraining times will vary according to the level of the Axie, the level of the Player, and the level of the gym equipment.\n\n\nThe levels have the following way to go up:\n\n\nTrainer Level: Training Axies and sending Axies to competitions.\n\n- Machine Upgrade Level: Using Upgrade Tools (will change visuals every 10 levels)\n- Gym Level: Training Axies\n- Axies: Training the 6 parts of their body\n- Additionally, players will be able to speed up training times using Energy Drinks and/or expanding their collection of cosmetics.\n\n**Minigames:**\nPlayers will have to meet requirements to unlock each of the mini-games.\nThese requirements could be of the style:\n\n- Reach a certain level with a specific Starter Axies.\n- Reach a certain Gym level\n- Reach a certain Trainer level\n- Own a certain type of Collectible Axie\n- Complete certain missions\n- Others',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 136,
      isIdWalletRequired: false,
    },
    description:
      'Axie Forge is a casual experience where players can train each part of an Axie to claim a greater reward and level them up.',
    devPortalAppId: '335c49aa-3051-4976-8d0d-6a8c0c111bb1',
    downvoteCount: 9,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/7GgPz-HCY0E?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/7GgPz-HCY0E/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464366-af01.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464365-af02.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464365-af03.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464366-af04.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464366-af05.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464366-af06.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464366-af07.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464367-af08.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1719464365-af09.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 18,
        name: 'Sports',
        slug: 'sports',
      },
      {
        description: '',
        id: 21,
        name: 'Simulation',
        slug: 'simulation',
      },
    ],
    id: 136,
    latestVersion: {
      createdAt: 1759290087,
      downloadResources: [
        {
          binaryPath: 'AxieForge.exe',
          binarySum:
            '0d5b2151ade06a7729c44e0ae4e2956195a2b40f9449f1c8102591d95442c43d',
          checksum:
            '51b0acba9965bb8d5331484f6f90c7d92d1b6c0df1bf1ff0f645667b0de0c12d',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-forge/e6ea67ca-3459-4ce3-b507-5c4b5a52dec0/windows-1.0.23.zip',
          os: 'windows',
          platform: 'desktop',
          size: 672415005,
        },
      ],
      id: 805,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'AxieForge.exe',
          binarySum:
            '0d5b2151ade06a7729c44e0ae4e2956195a2b40f9449f1c8102591d95442c43d',
          checksum:
            '51b0acba9965bb8d5331484f6f90c7d92d1b6c0df1bf1ff0f645667b0de0c12d',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-forge/e6ea67ca-3459-4ce3-b507-5c4b5a52dec0/windows-1.0.23.zip',
          os: 'windows',
          platform: 'desktop',
          size: 672415005,
        },
      ],
      state: 'published',
      tag: '1.0.23',
    },
    logoUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1719464329-sc192x192.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Axie Forge',
    officialWebsite: '',
    organization: {
      about: '',
      id: 114,
      logoUrl: '',
      name: 'Axie Fields',
      officialWebsite: '',
      partnershipType: 'axie-builder-program',
      slug: 'axie-fields',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'axie-forge',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/jyb837yv8T',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: ' https://x.com/AxieForge',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1719464334-tn534x376.png',
    upvoteCount: 98,
  },
  'wild-forest': {
    about:
      'Wild Forest is a single-screen real-time strategy game where players face off in fast, action-packed PvP battles. Compete by capturing areas, building armies, and outsmarting opponents to win by destroying their main base. Use up to 7 unique Unit cards, each with its own type, stats, and abilities, opening up many ways to play and surprising strategies. The game’s focus on skill keeps battles fair, reducing unfair play, bots, and pay-to-win.\n\n\n**Why Play Wild Forest?**\n\n🎮 **Easy to Learn**: Dive in fast—learn the basics in just 5 minutes!\n\n💰 **Free-to-Play and Earn**: Start earning Unit cards right after the tutorial.\n\n🖥 **Play Anywhere**: Available on Android, iOS, PC, and Mac.\n\n\n**About Zillion Whales**\n\nWild Forest is brought to you by Zillion Whales, a team from a game studio established in 2013, with a successful history of 6 strategy titles, including Mushroom Wars 2, an award-winning hit recognized by Apple as a Best Game in 2016 and 2017.\n\nBacked by the Best: Supported by top investors like Sky Mavis, L1D, Animoca Brands, OKX Ventures, Spartan Group, and Kahuna.',
    collectibles: [],
    config: {
      gameId: 126,
      isIdWalletRequired: false,
    },
    description:
      'Wild Forest: a free-to-play RTS with intense PvP battles and open economy. Collect, upgrade NFTs, and compete for big rewards!',
    devPortalAppId: '7e18d4db-36ca-4cf2-9045-38b3d3a679b0',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: 'https://cdn.skymavis.com/mavis-hub/assets/wild-forest/game-asset-cba823b1-aa7e-4f8a-9e5f-84ace2b71596.mp4',
      medium:
        'https://cdn.skymavis.com/mavis-hub/assets/wild-forest/game-asset-875b7f71-446f-45d5-8375-df4b7afc70f2.mp4',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/jIXNoshQa3o?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/jIXNoshQa3o/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172983-artgallery_1.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172983-artgallery_2.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172983-artgallery_3.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172982-artgallery_4.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172982-artgallery_5.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
    ],
    id: 126,
    latestVersion: {
      createdAt: 1758201311,
      downloadResources: [
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.zillionwhales.wildwars&pcampaignid=web_share&pli=1',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/us/app/wild-forest-real-time-strategy/id1605817135',
          os: 'ios',
          platform: 'mobile',
        },
        {
          downloadUrl: 'https://store.epicgames.com/p/wild-forest-c1e061',
          os: 'web',
          platform: 'web',
        },
      ],
      id: 801,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.zillionwhales.wildwars&pcampaignid=web_share&pli=1',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/us/app/wild-forest-real-time-strategy/id1605817135',
          os: 'ios',
          platform: 'mobile',
        },
        {
          downloadUrl: 'https://store.epicgames.com/p/wild-forest-c1e061',
          os: 'web',
          platform: 'web',
        },
      ],
      state: 'published',
      tag: '1.33.3',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172953-wf_logo.png',
    metaData: [],
    mode: 'live',
    name: 'Wild Forest',
    officialWebsite: 'https://playwildforest.io/',
    organization: {
      about: '',
      id: 110,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172588-zw_logo.png',
      name: 'Zillion Whales',
      officialWebsite: '',
      partnershipType: 'partner-studio',
      slug: 'zwhqcyp',
    },
    platforms: [
      {
        os: 'android-google-play',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
      {
        os: 'ios',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
      {
        os: 'web',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'web',
      },
    ],
    rating: null,
    slug: 'wild-forest',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/playwildforest',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/playwildforest',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 5,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1710172956-banner_wf.png',
    upvoteCount: null,
  },
  'axie-land-battles': {
    about:
      'Axie Land Battles is an asynchronous multiplayer autobattler game where players build unique teams of five Axies and a Land, then engage in a series of tactical battles. The game ends when the player either wins 12 matches or loses 3. Between each match, players can shop for upgrades, receive blessings, and make decisions that will shape their team\'s performance throughout the run. The game\'s structure is designed to offer diverse gameplay experiences, making each run unique and allowing players to experiment with various strategies.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
      {
        address: '0x8c811e3c958e190f5ec15fb376533a3398620500',
        description: '',
        id: 4,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575574-tab-land.png',
        name: 'Land',
        symbol: 'LAND',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 138,
      isIdWalletRequired: false,
    },
    description:
      'Axie Land Battles is a multiplayer auto-battler game! Build unique teams of five Axies and a Land, then engage in a series of tactical battles.',
    devPortalAppId: '',
    downvoteCount: 7,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/qH1Wz1PKJgU?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/qH1Wz1PKJgU/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050389-axielandbattles-ingame-battle.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050389-axielandbattles-ingame-combo-selector.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050389-axielandbattles-ingame-shop.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050390-axielandbattles-leaderboard.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1737726834-1729050378-axielandbattles-axies-menu.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050390-axielandbattles-menu-gui.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050389-axielandbattles-team-edit-menu.png',
        type: 'image',
      },
      {
        src: 'https://cdn.skymavis.com/mavis-hub/assets/1729050429-landscollage.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
      {
        description: '',
        id: 11,
        name: 'Auto Battler',
        slug: 'auto-battler',
      },
      {
        description: '',
        id: 23,
        name: 'Build & Battle',
        slug: 'build-and-battle',
      },
    ],
    id: 138,
    latestVersion: {
      createdAt: 1739565681,
      downloadResources: [
        {
          binaryPath: 'Axie Land Battles.exe',
          binarySum:
            'c700b2809e15436cd561657870b5e8a72c9c092a14ece6732fa7744138595e3b',
          checksum:
            '4fe6534891807508fdc39bf7b6c346895b1180cfcb2573b6adf0521bf307db6b',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-land-battles/99821592-2c06-4b81-87be-163aba2aef95/windows-0.2.7-ob.zip',
          os: 'windows',
          platform: 'desktop',
          size: 130073452,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-land-battles/b555befa-a32a-40a4-8ce0-0d81025fb769/android-0.2.7-ob.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      id: 690,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Axie Land Battles.exe',
          binarySum:
            'c700b2809e15436cd561657870b5e8a72c9c092a14ece6732fa7744138595e3b',
          checksum:
            '4fe6534891807508fdc39bf7b6c346895b1180cfcb2573b6adf0521bf307db6b',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-land-battles/99821592-2c06-4b81-87be-163aba2aef95/windows-0.2.7-ob.zip',
          os: 'windows',
          platform: 'desktop',
          size: 130073452,
        },
        {
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/axie-land-battles/b555befa-a32a-40a4-8ce0-0d81025fb769/android-0.2.7-ob.apk',
          os: 'android',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '0.2.7-ob',
    },
    logoUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1729050179-icon192x192.png',
    metaData: ['early-testing', 'greenlight'],
    mode: 'early-testing',
    name: 'Axie Land Battles',
    officialWebsite: '',
    organization: {
      about: '',
      id: 115,
      logoUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1729049937-handlocklogo.png',
      name: 'Handlock Studios',
      officialWebsite: '',
      partnershipType: 'axie-builder-program',
      slug: 'handlock-studios',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics:
              'Graphics card with DX10 capabilities (shader model 4.0) such as NVIDIA GeForce GTX 470 or AMD Radeon HD 6870',
            memory: '4 GB RAM',
            os: ' Windows 10 or newer',
            processor: 'Intel Core i5-2400 or AMD FX-8320 (or equivalent)',
            storage: '200MB',
          },
          recommended: {
            additionalNotes: '',
            graphics:
              'Graphics card with DX11 or DX12 capabilities (shader model 5.0) such as NVIDIA GeForce GTX 970 or AMD Radeon RX 570',
            memory: '8 GB RAM',
            os: ' Windows 10 or newer',
            processor: 'Intel Core i5-7500 or AMD Ryzen 3 1200 (or equivalent)',
            storage: '200MB',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'GPU with support for Vulkan',
            memory: '2 GB RAM',
            os: 'Android 5.1 (Lollipop) or later',
            processor:
              'Qualcomm Snapdragon 660, MediaTek Helio P60, or equivalent',
            storage: '200MB',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'GPU with support for Vulkan',
            memory: '8 GB RAM',
            os: 'Android 8.0 (Oreo) or later',
            processor: 'Qualcomm Snapdragon 888 or later',
            storage: '200MB',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'axie-land-battles',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/yTNV9Xptbc',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://x.com/AxieLandBattles',
      },
      {
        type: 'gitbook',
        url: 'https://handlock-studios.gitbook.io/axie-land-battles',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1737726696-image.png',
    upvoteCount: 173,
  },
  apeiron: {
    about:
      'Apeiron is the world’s first NFT-based real-time strategic card-battler x god game. Apeiron features a unique card-based action-adventure combat system combined with god game simulation gameplay inspired by classic god games like Populous and Black & White. Players will be able to build up planets from above before taking control of a powerful Avatar to dive into PvE dungeons, fight in PvP arenas, and solve the mysteries of the mythologically-inspired godiverse. Start your own divine journey today!',
    collectibles: [],
    config: {
      gameId: 124,
      isIdWalletRequired: false,
    },
    description: 'Real-time strategic card battler x god game',
    devPortalAppId: '299bd097-3687-4cde-a329-fb234dfb488a',
    downvoteCount: null,
    fullThumbnailUrl: {
      high: 'https://cdn.skymavis.com/mavis-hub/assets/apeiron/game-asset-8e7e73ba-761d-4661-9c07-6a770f0d7823.mp4',
      medium:
        'https://cdn.skymavis.com/mavis-hub/assets/apeiron/game-asset-3a4f76a8-7c03-4366-9c84-c4e2b7619a0f.mp4',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/Hx6-H1g8KcM?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/Hx6-H1g8KcM/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709178757-01-combineforceswithyourapostles!.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709178757-02-masteryouravataruniqueskill.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709178757-03-deep-tacticalaction.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709178757-04-3best2realtimebattle.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1709178757-05-constantprogress!earnepicrewards.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 3,
        name: 'Strategy',
        slug: 'strategy',
      },
      {
        description: '',
        id: 4,
        name: 'Adventure',
        slug: 'adventure',
      },
    ],
    id: 124,
    latestVersion: {
      createdAt: 1755334569,
      downloadResources: [
        {
          binaryPath: 'Apeiron.app/Contents/MacOS/Apeiron',
          binarySum:
            'a943f2839ba22a6df8f439811e33318804763dc6aaefc0beddb23a21b12be0cc',
          checksum:
            '00009f562fcbec3bfb55828687faf15c44c0fce2343ffceb0a90bbbf8443e0ad',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/apeiron/11900f9a-a671-47ac-a4b6-3c8297959566/macos-1.6.1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 2228116304,
        },
        {
          binaryPath: 'Apeiron.exe',
          binarySum:
            'f02fc9bc72c84162e85af0f64c1093a43f84962e7be86537a21c3c246c944b9a',
          checksum:
            '939a32fef2324701ba669e32b691450c2d7086347f30b680c01a82a51891317e',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/apeiron/3053b9c1-f1a7-4790-8843-bd0ca4dd4a46/windows-1.6.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 2195565406,
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.fooniemagus.apeiron&hl=en',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/hk/app/apeiron-godling-genesis/id6468012497?l=en',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      id: 791,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Apeiron.app/Contents/MacOS/Apeiron',
          binarySum:
            'a943f2839ba22a6df8f439811e33318804763dc6aaefc0beddb23a21b12be0cc',
          checksum:
            '00009f562fcbec3bfb55828687faf15c44c0fce2343ffceb0a90bbbf8443e0ad',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/apeiron/11900f9a-a671-47ac-a4b6-3c8297959566/macos-1.6.1.zip',
          os: 'macos',
          platform: 'desktop',
          size: 2228116304,
        },
        {
          binaryPath: 'Apeiron.exe',
          binarySum:
            'f02fc9bc72c84162e85af0f64c1093a43f84962e7be86537a21c3c246c944b9a',
          checksum:
            '939a32fef2324701ba669e32b691450c2d7086347f30b680c01a82a51891317e',
          downloadUrl:
            'https://cdn.skymavis.com/mavis-hub/game-files/assets/apeiron/3053b9c1-f1a7-4790-8843-bd0ca4dd4a46/windows-1.6.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 2195565406,
        },
        {
          downloadUrl:
            'https://play.google.com/store/apps/details?id=com.fooniemagus.apeiron&hl=en',
          os: 'android-google-play',
          platform: 'mobile',
        },
        {
          downloadUrl:
            'https://apps.apple.com/hk/app/apeiron-godling-genesis/id6468012497?l=en',
          os: 'ios',
          platform: 'mobile',
        },
      ],
      state: 'published',
      tag: '1.6.1',
    },
    logoUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1733306114-104_logo_256x256.png',
    metaData: [],
    mode: 'live',
    name: 'Apeiron',
    officialWebsite: '',
    organization: {
      about: '',
      id: 108,
      logoUrl:
        'https://cdn.skymavis.com/mavis-hub/assets/1718710130-logo-black.jpeg',
      name: 'Foonie Magus',
      officialWebsite: 'https://www.fooniemagus.com/',
      partnershipType: 'partner-studio',
      slug: 'foonie-magus',
    },
    platforms: [
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'Macbook Pro 2019\n\n',
            memory: '8 GB of RAM\n\n',
            os: 'Mac OS X 10.15\n\n',
            processor: 'Macbook Pro 2019\n\n',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'Macbook Pro M1\n\n',
            memory: '16 GB of RAM\n\n',
            os: 'Mac OS X 10.15\n\n',
            processor: 'Macbook Pro M1\n\n',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: 'GTX 1070 or higher\n\n',
            memory: '6 GB DDR3 Memory\n\n',
            os: 'Windows 10 64-bit version\n',
            processor:
              'Windows 10\n\nQuad-core Intel or AMD, 2.5 GHz or faster\n\n',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: 'Nvidia RTX 2070 or higher\n\n',
            memory: '8 GB DDR4 Memory or higher\n\n',
            os: 'Windows 10 64-bit version\n\n',
            processor: '6-core 8th generation CPU\n\n',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'android-google-play',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '4GB Ram\n',
            os: '',
            processor: 'Snapdragon 7 Gen 1 or up\n',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '4GB Ram\n',
            os: '',
            processor: 'Snapdragon 7 Gen 1 or up\n',
            storage: '',
          },
        },
        type: 'mobile',
      },
      {
        os: 'ios',
        requirements: {
          minimum: {
            additionalNotes: 'iPhone 13 Up\n',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: 'iPhone 14 up\n',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
    ],
    rating: null,
    slug: 'apeiron',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://discord.gg/apeiron-doodaria',
      },
      {
        type: 'facebook',
        url: 'https://www.facebook.com/Apeironnft',
      },
      {
        type: 'linkedin',
        url: 'https://www.linkedin.com/company/foonie-magus',
      },
      {
        type: 'twitter',
        url: 'https://x.com/ApeironNFT',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://cdn.skymavis.com/mavis-hub/assets/1733306318-105_banner_1920x1080.jpg',
    upvoteCount: null,
  },
  'infinity-soccer': {
    about:
      'Infinity Soccer is an innovative NFT-based sports game that takes the world of Axie Infinity into the realm of competitive soccer. The game is set in a 2D environment where players engage in exhilarating 1 vs 1 soccer matches using their unique Axies as players. Each Axie has six distinct body parts, each linked to a card representing a power or stat improvement, adding a layer of strategy to the gameplay.\n\nThe main objective of Infinity Soccer is to outscore your opponent by strategically utilizing your Axies\' powers, skills, and teamwork within a 90-second match. The game emphasizes both tactical gameplay and intuitive controls, making it accessible to players of all skill levels, from casual mobile gamers to esports enthusiasts.\n\nPlayers can participate in two primary modes: Friendly and Ranked matches. Friendly matches provide an unranked environment for practice and experimentation, allowing players to challenge friends or engage in casual matches using matchmaking. Ranked matches are at the core of the competitive experience, where players aim to climb the divisions through victories to earn rewards and recognition. To participate in Ranked matches, players must register at least one team of three Axies, paying their salaries for the season. They can register up to three teams, with benefits such as increased playable games and ranking opportunities.\n\nGadgets, accessories, and NFT stadiums offer customization options that allow players to personalize their Axies and enhance their performance. Some accessories provide stat bonuses or unique abilities, adding a strategic element to matches. Additionally, NFT stadiums provide a platform for players to showcase their individuality and even potentially monetize their stadium\'s branding through sponsorship deals.\n\nInfinity Soccer is designed to cater to a diverse audience, from existing Axie Infinity players to those who enjoy competitive and intuitive sports games on mobile platforms. The game\'s evolving ecosystem, coupled with the potential for expanding to various sports under the "Axie Infinity Sports" umbrella, creates a dynamic and engaging experience that encourages players to continuously improve their skills and achieve recognition in the world of virtual sports.\n\nAs Infinity Soccer continues to evolve, our commitment to refining gameplay, incorporating player feedback, and introducing new features ensures a captivating and ever-evolving experience that resonates with the competitive spirit of gamers and NFT enthusiasts alike.',
    collectibles: [
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 16,
      isIdWalletRequired: false,
    },
    description: 'Infinity Soccer: The Ultimate Axie Champions',
    devPortalAppId: '',
    downvoteCount: 59,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259748-01-MainMenu-AlessandroGregori.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259756-02-AxieMenu-AlessandroGregori.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259764-03-Collection-AlessandroGregori.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259764-Challenge3-AlessandroGregori.jpg',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259764-Practice3-AlessandroGregori.jpg',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 1,
        name: 'Early access',
        slug: 'early-access',
      },
      {
        description: '',
        id: 18,
        name: 'Sports',
        slug: 'sports',
      },
    ],
    id: 16,
    latestVersion: {
      createdAt: 1694587146,
      downloadResources: [
        {
          binaryPath: 'Infinity Soccer.exe',
          binarySum:
            '4e1f7305cb7538456a9fcc672df9aeab3e675fd852bc85d3165fc9a35014f480',
          checksum:
            'eb42cd18d5e47e5395015afed95f0ae47253b5eea94e1a36e23586546a51f802',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/infinity-soccer/5f66ffef-6c52-4673-a7d2-0a2526d9d7b7/infinity-soccer-0.1.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 53145683,
        },
      ],
      id: 137,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          binaryPath: 'Infinity Soccer.exe',
          binarySum:
            '4e1f7305cb7538456a9fcc672df9aeab3e675fd852bc85d3165fc9a35014f480',
          checksum:
            'eb42cd18d5e47e5395015afed95f0ae47253b5eea94e1a36e23586546a51f802',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-hub-game-storage/assets/infinity-soccer/5f66ffef-6c52-4673-a7d2-0a2526d9d7b7/infinity-soccer-0.1.1.zip',
          os: 'windows',
          platform: 'desktop',
          size: 53145683,
        },
      ],
      state: 'published',
      tag: '0.1.2',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259699-InfinitySoccer.jpg',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Infinity Soccer: The Ultimate Axie Champions',
    officialWebsite: '',
    organization: {
      about: '',
      id: 7,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259415-Logo.png',
      name: 'PixelInfinityStudios',
      officialWebsite: '',
      partnershipType: 'community-developer',
      slug: 'pixel-infinity',
    },
    platforms: [
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'infinity-soccer',
    socialLinks: [
      {
        type: 'discord',
        url: '',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: '',
      },
      {
        type: 'gitbook',
        url: 'https://488ed70b-4390-417b-afd2-83d8e98115fc.filesusr.com/ugd/bbf615_2c2808412ff7457bbe2694551a5df693.pdf',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1692259614-InfinitySoccer.jpg',
    upvoteCount: 281,
  },
  aiw: {
    about:
      'Welcome to the world of "Axie Infinity War," the ultimate 2.5D platform multiplayer shooter game where players can earn real SLP and other exciting rewards! Get ready to battle it out with other players from around the world for the ultimate glory and bragging rights.\n\nIn Axie Infinity War, players will take on the role of Axies, cute and powerful creatures with unique abilities and strengths. Each Axie has a set of powers that they can use to defeat their opponents and claim victory.\n\nThe game takes place in a colourful and vibrant world full of obstacles, traps, and other hazards. Players will need to use their platforming skills and quick reflexes to navigate the terrain and avoid danger while also engaging in intense battles with other Axies.\n\nThe goal of the game is simple: be the one with the highest standing! Players will be dropped onto the battlefield and must fight to survive . Along the way, they can collect power-ups and other items that will give them an edge over their opponents.\n\nBut that\'s not all - in AIW, players can also earn real SLP and other exciting rewards by competing in matches and completing challenges. The more victories they achieve, the more rewards they\'ll earn!\n\nSo what are you waiting for? Join the battle today and show off your skills as an Axie warrior. With thrilling battles, exciting rewards, and endless possibilities, AIW is the ultimate multiplayer shooter game for players of all skill levels.',
    collectibles: [
      {
        address: '0xa8754b9fa15fc18bb59458815510e40a12cd2014',
        description: '',
        id: 2,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696576115-slp.png',
        name: 'Smooth Love Potion',
        symbol: 'SLP',
        type: 'ERC20',
      },
      {
        address: '0x32950db2a7164ae833121501c797d79e7b79d74c',
        description: '',
        id: 3,
        logoUrl:
          'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1696575551-tab-axie.png',
        name: 'Axie',
        symbol: 'AXIE',
        type: 'ERC721',
      },
    ],
    config: {
      gameId: 13,
      isIdWalletRequired: false,
    },
    description:
      'A 2.5d Platform Battle Royale Game for the ultimate glory and exciting rewards',
    devPortalAppId: '',
    downvoteCount: 31,
    event: {
      bannerUrl:
        'https://storage.googleapis.com/sm-dev-mavishub-cdn/stag/1684727775-Frame1148.png',
      code: 'greenlight',
      createdAt: 1687417567,
      description:
        'Disclaimer: Greenlight games are in an extremely early stage of development. These products are made by Indie game devs and community members. Descriptions may represent future aspirations rather than current functionality and features.',
      eventType: 'vote',
      id: 1,
      priority: 0,
      slug: 'greenlight',
      subTitle: 'Vote to choose the next games listed on Mavis Hub!',
      title: 'Greenlight',
      totalGame: 13,
      websiteUrl: 'https://skymavis.com',
    },
    fullThumbnailUrl: {
      high: '',
      medium: '',
    },
    gallery: [
      {
        src: 'https://www.youtube.com/embed/tzWj_psgAig?controls=0&loop=1&autoplay=1&showinfo=0',
        thumbnail: 'https://img.youtube.com/vi/tzWj_psgAig/mqdefault.jpg',
        type: 'embed',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651136-Screenshot2023-08-01at10.33.28AM.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651134-Screenshot2023-08-01at10.33.48AM.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651135-Screenshot2023-08-01at10.35.36AM.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651136-Screenshot2023-08-01at10.36.13AM.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651136-Screenshot2023-08-01at10.38.13AM.png',
        type: 'image',
      },
      {
        src: 'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691651133-Screenshot2023-08-01at10.38.17AM.png',
        type: 'image',
      },
    ],
    genres: [
      {
        description: '',
        id: 20,
        name: 'Fighting',
        slug: 'fighting',
      },
      {
        description: '',
        id: 22,
        name: 'Survival',
        slug: 'survival',
      },
    ],
    id: 13,
    latestVersion: {
      createdAt: 1692265608,
      downloadResources: [
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692258909/aiw_2.0_beta.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          binaryPath: 'AIW Beta.exe',
          binarySum:
            'ba3be2030f9a7a3414ef6ad0835840d8d70012dfcc9c8b815b66dfa655b1abe7',
          checksum:
            '5959388b9f8d65733707a1f418d5458d1ba4af79dfec463d34db4754f68e800f',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692257697/aiw2.0beta.zip',
          os: 'windows',
          platform: 'desktop',
          size: 176741560,
        },
        {
          binaryPath: 'AIW 2.0 Beta.app/Contents/MacOS/AIW Beta',
          binarySum:
            'a21c8145743c3bf473ca3c8e13d35563946734d8a37a068b9636cae67e3a84f0',
          checksum:
            'd8da0456270f30371be2b2fd8e2e1a59ac9a6c4056e71b2b7e66a8284bafee8e',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692258908/aiw2.0beta.zip',
          os: 'macos',
          platform: 'desktop',
          size: 208294945,
        },
      ],
      id: 115,
      isLatest: true,
      patchNotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      patchnotes: {
        brief: '',
        content: '',
        gameId: 0,
        thumbnailUrl: '',
        title: '',
      },
      resources: [
        {
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692258909/aiw_2.0_beta.apk',
          os: 'android',
          platform: 'mobile',
        },
        {
          binaryPath: 'AIW Beta.exe',
          binarySum:
            'ba3be2030f9a7a3414ef6ad0835840d8d70012dfcc9c8b815b66dfa655b1abe7',
          checksum:
            '5959388b9f8d65733707a1f418d5458d1ba4af79dfec463d34db4754f68e800f',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692257697/aiw2.0beta.zip',
          os: 'windows',
          platform: 'desktop',
          size: 176741560,
        },
        {
          binaryPath: 'AIW 2.0 Beta.app/Contents/MacOS/AIW Beta',
          binarySum:
            'a21c8145743c3bf473ca3c8e13d35563946734d8a37a068b9636cae67e3a84f0',
          checksum:
            'd8da0456270f30371be2b2fd8e2e1a59ac9a6c4056e71b2b7e66a8284bafee8e',
          downloadUrl:
            'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/aiw/1692258908/aiw2.0beta.zip',
          os: 'macos',
          platform: 'desktop',
          size: 208294945,
        },
      ],
      state: 'published',
      tag: '0.1.0',
    },
    logoUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650918-AIWlogo.png',
    metaData: ['early-testing'],
    mode: 'early-testing',
    name: 'Axie Infinity War',
    officialWebsite: '',
    organization: {
      about: '',
      id: 6,
      logoUrl:
        'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650637-AIWlogo.png',
      name: 'AIW Team',
      officialWebsite: '',
      partnershipType: 'axie-builder-program',
      slug: 'aiw-team',
    },
    platforms: [
      {
        os: 'android',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'mobile',
      },
      {
        os: 'macos',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
      {
        os: 'windows',
        requirements: {
          minimum: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
          recommended: {
            additionalNotes: '',
            graphics: '',
            memory: '',
            os: '',
            processor: '',
            storage: '',
          },
        },
        type: 'desktop',
      },
    ],
    rating: null,
    slug: 'aiw',
    socialLinks: [
      {
        type: 'discord',
        url: 'https://t.co/KubDIXJGAs',
      },
      {
        type: 'facebook',
        url: '',
      },
      {
        type: 'linkedin',
        url: '',
      },
      {
        type: 'twitter',
        url: 'https://twitter.com/AxieWar',
      },
      {
        type: 'gitbook',
        url: '',
      },
    ],
    storeMerchantId: 0,
    thumbnailUrl:
      'https://storage.googleapis.com/sm-prod-mavis-hub-cdn/assets/1691650786-AIWtwitter_cover.jpg',
    upvoteCount: 340,
  },
}
